(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[966],{

/***/ 7017:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account",
      function () {
        return __webpack_require__(7683);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_common_mainButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7749);
/* harmony import */ var _contexts_providers_language__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9327);
/* harmony import */ var _localization_en__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1257);
/* harmony import */ var _localization_fr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1916);





var ApplicationSuccessful = function() {
    var language = (0,_contexts_providers_language__WEBPACK_IMPORTED_MODULE_2__/* .useLanguage */ .ZK)().language;
    var successfulTexts = language === "En" ? _localization_en__WEBPACK_IMPORTED_MODULE_3__/* ["default"].applyPage.successful */ .Z.applyPage.successful : _localization_fr__WEBPACK_IMPORTED_MODULE_4__/* ["default"].applyPage.successful */ .Z.applyPage.successful;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: successfulTexts.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_mainButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                uiOnly: true,
                style: {
                    color: "var(--color-green)",
                    borderColor: "var(--color-green)"
                },
                children: successfulTexts.header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: successfulTexts.response
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: successfulTexts.validatedTitle
                    }),
                    [
                        successfulTexts.validatedMessage1,
                        successfulTexts.validatedMessage2,
                        successfulTexts.validatedMessage3, 
                    ].map(function(validationStep, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            children: [
                                "→ ",
                                validationStep
                            ]
                        }, "success-validation-step-".concat(i));
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ApplicationSuccessful);


/***/ }),

/***/ 561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__);




var Img = function(param) {
    var src = param.src, alt = param.alt, _lazyLoad = param.lazyLoad, lazyLoad = _lazyLoad === void 0 ? true : _lazyLoad, containerProps = param.containerProps, imgProps = param.imgProps, children = param.children, aspectRatio = param.aspectRatio;
    var normalImagePlaceholder = lazyLoad && typeof (imgProps === null || imgProps === void 0 ? void 0 : imgProps.placeholder) == "string" ? imgProps === null || imgProps === void 0 ? void 0 : imgProps.placeholder : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, containerProps), {
        children: [
            lazyLoad ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__.LazyLoadImage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                src: src,
                alt: alt
            }, imgProps)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("picture", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    src: src,
                    alt: alt
                }, imgProps), {
                    placeholder: normalImagePlaceholder,
                    style: {
                        aspectRatio: aspectRatio
                    }
                }))
            }),
            children
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Img);


/***/ }),

/***/ 7824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var Spacer = function(param) {
    var width = param.width, height = param.height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            width: width,
            height: height
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spacer);


/***/ }),

/***/ 7911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _common_mainButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7749);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5163);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Filter = function(param) {
    var mapToName = param.mapToName, itemsColor = param.itemsColor, items = param.items, hiddenItems = param.hiddenItems, filteredItems = param.filteredItems, className = param.className, _relative = param.relative, relative = _relative === void 0 ? true : _relative, handleSetFilter = param.handleSetFilter;
    var filteredItemsSet = hiddenItems ? items.filter(function(item) {
        return !hiddenItems || !(hiddenItems === null || hiddenItems === void 0 ? void 0 : hiddenItems.includes(item));
    }) : items;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().query;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (query.tab) {
            filteredItemsSet.map(function(item) {
                if (mapToName(item) === query.tab) {
                    handleSetFilter(item);
                }
            });
        }
    }, [
        query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: [
            relative ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().relativeFilter) : (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().genericFilter),
            className, 
        ].join(" "),
        children: filteredItemsSet.map(function(item, i) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_mainButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: [
                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().item),
                    filteredItems.includes(item) ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().selected) : null, 
                ].join(" "),
                onClick: function() {
                    handleSetFilter(item);
                },
                style: (itemsColor === null || itemsColor === void 0 ? void 0 : itemsColor[i]) ? {
                    color: itemsColor === null || itemsColor === void 0 ? void 0 : itemsColor[i]
                } : {},
                children: mapToName(item)
            }, i);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Filter);


/***/ }),

/***/ 3218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _contexts_providers_language__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9327);
/* harmony import */ var _localization_en__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1257);
/* harmony import */ var _localization_fr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1916);
/* harmony import */ var _utils_constants_capacity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5380);
/* harmony import */ var _utils_constants_locations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8891);
/* harmony import */ var _common_mainButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7749);
/* harmony import */ var _filter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7911);
/* harmony import */ var _tagFilter__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(664);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5664);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_9__);










var FullFilter = function(param) {
    var fullFilter = param.fullFilter, useCapacityFilter = param.useCapacityFilter, handleResetFilter = param.handleResetFilter, handleSetLocationFilter = param.handleSetLocationFilter, handleSetCapacityFilter = param.handleSetCapacityFilter, handleSetTagFilter = param.handleSetTagFilter, _relative = param.relative, relative = _relative === void 0 ? true : _relative, tags = param.tags;
    var language = (0,_contexts_providers_language__WEBPACK_IMPORTED_MODULE_1__/* .useLanguage */ .ZK)().language;
    var accountTexts = language === "En" ? _localization_en__WEBPACK_IMPORTED_MODULE_2__/* ["default"].accountPage */ .Z.accountPage : _localization_fr__WEBPACK_IMPORTED_MODULE_3__/* ["default"].accountPage */ .Z.accountPage;
    var displayAll = !fullFilter.locations.length && !fullFilter.capacities.length && !fullFilter.tags.length && !fullFilter.dates;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: relative ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().relativeFilter) : (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().genericFilter),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_mainButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: [
                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().item),
                    displayAll ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().selected) : null
                ].join(" "),
                onClick: handleResetFilter,
                children: accountTexts.all
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: "\xa0\xa0\xa0"
            }),
            accountTexts.locations,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_filter__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                items: _utils_constants_locations__WEBPACK_IMPORTED_MODULE_5__/* .locations */ .Kl,
                itemsColor: _utils_constants_locations__WEBPACK_IMPORTED_MODULE_5__/* .locations.map */ .Kl.map(function(location) {
                    return _utils_constants_locations__WEBPACK_IMPORTED_MODULE_5__/* .locationToColors */ .zL[location];
                }),
                filteredItems: fullFilter.locations,
                handleSetFilter: handleSetLocationFilter,
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().filter),
                mapToName: function(item) {
                    return _utils_constants_locations__WEBPACK_IMPORTED_MODULE_5__/* .locationToNames */ .yt[item];
                }
            }),
            useCapacityFilter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    "Participants",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_filter__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        items: _utils_constants_capacity__WEBPACK_IMPORTED_MODULE_4__/* .capacities */ .LO,
                        filteredItems: fullFilter.capacities,
                        handleSetFilter: handleSetCapacityFilter,
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().filter),
                        mapToName: function(item) {
                            return _utils_constants_capacity__WEBPACK_IMPORTED_MODULE_4__/* .capacityToNames */ .aQ[item];
                        }
                    })
                ]
            }),
            tags.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    "Tags",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tagFilter__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        tags: tags,
                        filter: fullFilter.tags,
                        handleSetFilter: handleSetTagFilter,
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().filter)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullFilter);


/***/ }),

/***/ 8408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2519);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var Loader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loading),
            (_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loading06)
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "S",
                children: "S"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "I",
                children: "I"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "L",
                children: "L"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "E",
                children: "E"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "N",
                children: "N"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "C",
                children: "C"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "I",
                children: "I"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "0",
                children: "O"
            })
        ]
    });
};


/***/ }),

/***/ 664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _contexts_providers_language__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9327);
/* harmony import */ var _common_mainButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7749);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9163);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var TagFilter = function(param) {
    var tags = param.tags, filter = param.filter, className = param.className, _relative = param.relative, relative = _relative === void 0 ? true : _relative, handleSetFilter = param.handleSetFilter, handleResetFilter = param.handleResetFilter;
    var language = (0,_contexts_providers_language__WEBPACK_IMPORTED_MODULE_1__/* .useLanguage */ .ZK)().language;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            relative ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().relativeFilter) : (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().genericFilter),
            className, 
        ].join(" "),
        children: [
            handleResetFilter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_mainButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: [
                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().item),
                    filter.length === 0 ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().selected) : undefined, 
                ].join(" "),
                onClick: function() {
                    handleResetFilter();
                },
                children: language === "En" ? "All" : "Tout"
            }, 0),
            tags.map(function(tag) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_mainButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: [
                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().item),
                        filter.includes(tag) ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().selected) : undefined, 
                    ].join(" "),
                    onClick: function() {
                        handleSetFilter(tag);
                    },
                    children: tag["name".concat(language)]
                }, tag.id);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TagFilter);


/***/ }),

/***/ 3722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useGrabToScroll; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useGrabToScroll = function(ref, options) {
    var _$ref = options !== null && options !== void 0 ? options : {}, acceleration = _$ref.acceleration, accelerationX = _$ref.accelerationX, accelerationY = _$ref.accelerationY, grabCursor = _$ref.grabCursor, removeScrollBar = _$ref.removeScrollBar;
    var _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isDown = _$ref1[0], setIsDown = _$ref1[1];
    var _$ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), startX = _$ref2[0], setStartX = _$ref2[1];
    var _$ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), startY = _$ref3[0], setStartY = _$ref3[1];
    var _$ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), scrollLeft = _$ref4[0], setScrollLeft = _$ref4[1];
    var _$ref5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), scrollTop = _$ref5[0], setScrollTop = _$ref5[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var elm = ref.current;
        if (!elm) return;
        if (removeScrollBar) {
            elm.classList.add("no-scrollbar");
        }
        var handleMouseDown = function(e) {
            setIsDown(true);
            setStartX(e.pageX - elm.offsetLeft);
            setStartY(e.pageY - elm.offsetTop);
            setScrollLeft(elm.scrollLeft + 1);
            setScrollTop(elm.scrollTop + 1);
            if (grabCursor) {
                elm.style.cursor = "grabbing";
            }
        };
        var handleMouseLeave = function() {
            setIsDown(false);
        };
        var handleMouseUp = function() {
            setIsDown(false);
            if (grabCursor) {
                elm.style.removeProperty("cursor");
            }
        };
        var handleMouseMove = function(e) {
            if (!isDown) return;
            e.preventDefault();
            var x = e.pageX - elm.offsetLeft;
            var _$ref;
            var walkX = (x - startX) * ((_$ref = accelerationX !== null && accelerationX !== void 0 ? accelerationX : acceleration) !== null && _$ref !== void 0 ? _$ref : 1); //scroll-fast
            elm.scrollLeft = scrollLeft - walkX;
            var y = e.pageY - elm.offsetTop;
            var _$ref1;
            var walkY = (y - startY) * ((_$ref1 = accelerationY !== null && accelerationY !== void 0 ? accelerationY : acceleration) !== null && _$ref1 !== void 0 ? _$ref1 : 1); //scroll-fast
            elm.scrollTop = scrollTop - walkY;
        };
        elm.addEventListener("mousedown", handleMouseDown);
        elm.addEventListener("mouseleave", handleMouseLeave);
        elm.addEventListener("mouseup", handleMouseUp);
        elm.addEventListener("mousemove", handleMouseMove);
        return function() {
            elm.removeEventListener("mousedown", handleMouseDown);
            elm.removeEventListener("mouseleave", handleMouseLeave);
            elm.removeEventListener("mouseup", handleMouseUp);
            elm.removeEventListener("mousemove", handleMouseMove);
        };
    }, [
        ref,
        isDown,
        scrollLeft,
        scrollTop,
        startX,
        startY,
        acceleration,
        accelerationX,
        accelerationY,
        grabCursor,
        removeScrollBar, 
    ]);
};


/***/ }),

/***/ 7683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ account; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/api/clients/axios.ts
var axios = __webpack_require__(6912);
;// CONCATENATED MODULE: ./src/api/events/getAllEvents.ts



var getAllEvents = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,axios/* sendRequest */.wG)({
                        method: "get",
                        url: "/event/all"
                    });
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getAllEvents() {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/components/ui/modal/index.tsx
var ui_modal = __webpack_require__(5136);
// EXTERNAL MODULE: ./src/contexts/providers/language.tsx
var providers_language = __webpack_require__(9327);
// EXTERNAL MODULE: ./src/components/failedSubscriptionPopup/index.module.scss
var index_module = __webpack_require__(9966);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/failedSubscriptionPopup/index.tsx





var FailedSubscriptionPopup = function(param) {
    var firstName = param.firstName, lastName = param.lastName;
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var ref = (0,react.useState)(true), modalOpen = ref[0], setModalOpen = ref[1];
    var handleSetModalClose = function() {
        setModalOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_modal/* default */.Z, {
        open: modalOpen,
        onClose: handleSetModalClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: language === "En" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Hello ",
                        firstName,
                        " ",
                        lastName,
                        ",",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "A problem occurred during the payment of your subscription.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Please resolve the issue in order to access our platform."
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Bonjour ",
                        firstName,
                        " ",
                        lastName,
                        ",",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Un probl\xe8me est survenu lors du paiement de votre abonnement.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Merci de mettre \xe0 jour votre moyen de paiement pour r\xe9activer votre abonnement au Silencio."
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var failedSubscriptionPopup = (FailedSubscriptionPopup);

// EXTERNAL MODULE: ./src/components/ui/filter/index.tsx
var ui_filter = __webpack_require__(7911);
// EXTERNAL MODULE: ./src/contexts/providers/auth.tsx
var auth = __webpack_require__(7322);
;// CONCATENATED MODULE: ./src/types/account/account.types.ts
var AccountSectionEnum;
(function(AccountSectionEnum) {
    AccountSectionEnum["PROGRAMMATION"] = "Programmation";
    AccountSectionEnum["AGENDA"] = "Agenda";
    AccountSectionEnum["MEMBERSHIP"] = "Membership";
    AccountSectionEnum["SPONSORSHIP"] = "Parrainage";
    AccountSectionEnum["BIRTHDAY"] = "Anniversaire";
})(AccountSectionEnum || (AccountSectionEnum = {}));
var AccountSectionEnumEn;
(function(AccountSectionEnumEn) {
    AccountSectionEnumEn["PROGRAMMATION"] = "Programmation";
    AccountSectionEnumEn["AGENDA"] = "Agenda";
    AccountSectionEnumEn["MEMBERSHIP"] = "Membership";
    AccountSectionEnumEn["SPONSORSHIP"] = "Sponsorship";
    AccountSectionEnumEn["BIRTHDAY"] = "Birthday";
})(AccountSectionEnumEn || (AccountSectionEnumEn = {}));

// EXTERNAL MODULE: ./src/types/auth/userEnums.types.ts
var userEnums_types = __webpack_require__(5997);
// EXTERNAL MODULE: ./src/types/subscription/subscription.types.ts
var subscription_types = __webpack_require__(1705);
;// CONCATENATED MODULE: ./src/utils/constants/account.ts

var accountSections = [
    AccountSectionEnum.PROGRAMMATION,
    AccountSectionEnum.AGENDA,
    AccountSectionEnum.MEMBERSHIP,
    AccountSectionEnum.SPONSORSHIP,
    AccountSectionEnum.BIRTHDAY, 
];
var accountSectionsEn = [
    AccountSectionEnumEn.PROGRAMMATION,
    AccountSectionEnumEn.AGENDA,
    AccountSectionEnumEn.MEMBERSHIP,
    AccountSectionEnumEn.SPONSORSHIP,
    AccountSectionEnumEn.BIRTHDAY, 
];
var getAccountSectionsByLanguage = function(language) {
    return language === "Fr" ? accountSections : accountSectionsEn;
};

// EXTERNAL MODULE: ./src/contexts/providers/events.tsx
var events = __webpack_require__(9681);
// EXTERNAL MODULE: ./src/components/account/cannotBookPopup/cannotBookPopup.module.scss
var cannotBookPopup_module = __webpack_require__(2033);
var cannotBookPopup_module_default = /*#__PURE__*/__webpack_require__.n(cannotBookPopup_module);
;// CONCATENATED MODULE: ./src/components/account/cannotBookPopup/index.tsx



var CannotBookPopup = function(param) {
    var open = param.open, setOpen = param.setOpen;
    var handleCloseModal = function() {
        setOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_modal/* default */.Z, {
        open: open,
        onClose: handleCloseModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (cannotBookPopup_module_default()).container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (cannotBookPopup_module_default()).text,
                children: "Vous avez atteint le nombre maximal des \xe9v\xe9nements qu’il vous est possible de r\xe9server en simultan\xe9. Cette r\xe8gle permet de garantir que tous les membres puissent profiter des \xe9v\xe9nements culturels."
            })
        })
    });
};
/* harmony default export */ var account_cannotBookPopup = (CannotBookPopup);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
;// CONCATENATED MODULE: ./src/api/events/bookEventById.ts



var bookEventById = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
        var guests, eventId, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    guests = input.guests, eventId = input.eventId;
                    _ctx.next = 3;
                    return (0,axios/* sendRequest */.wG)({
                        method: "post",
                        url: "/event/book/".concat(eventId),
                        data: {
                            guests: guests
                        }
                    });
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function bookEventById(input) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/api/events/cancelEventById.ts



var cancelEventById = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
        var eventId, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    eventId = input.eventId;
                    _ctx.next = 3;
                    return (0,axios/* sendRequest */.wG)({
                        method: "post",
                        url: "/event/cancel/".concat(eventId)
                    });
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function cancelEventById(input) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
;// CONCATENATED MODULE: ./src/api/events/inviteToEventById.ts




var inviteToEventById = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
        var eventId, data, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    eventId = input.eventId, data = (0,_object_without_properties/* default */.Z)(input, [
                        "eventId"
                    ]);
                    _ctx.next = 3;
                    return (0,axios/* sendRequest */.wG)({
                        method: "post",
                        url: "/event/invite/".concat(eventId),
                        data: data
                    });
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function inviteToEventById(input) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/api/events/uninviteFromEventById.ts




var uninviteFromEventById = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
        var eventId, data, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    eventId = input.eventId, data = (0,_object_without_properties/* default */.Z)(input, [
                        "eventId"
                    ]);
                    _ctx.next = 3;
                    return (0,axios/* sendRequest */.wG)({
                        method: "post",
                        url: "/event/uninvite/".concat(eventId),
                        data: data
                    });
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function uninviteFromEventById(input) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/components/common/img/index.tsx
var img = __webpack_require__(561);
// EXTERNAL MODULE: ./src/components/common/mainButton/index.tsx + 1 modules
var mainButton = __webpack_require__(7749);
// EXTERNAL MODULE: ./src/localization/en.ts
var en = __webpack_require__(1257);
// EXTERNAL MODULE: ./src/localization/fr.ts
var fr = __webpack_require__(1916);
// EXTERNAL MODULE: ./src/types/event/eventEnums.type.ts
var eventEnums_type = __webpack_require__(2224);
// EXTERNAL MODULE: ./src/utils/constants/locations.ts
var locations = __webpack_require__(8891);
;// CONCATENATED MODULE: ./src/utils/functions/date.functions.ts
var formatSimpleDate = function(date) {
    var language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "En";
    return new Date(date).toLocaleDateString(language === "En" ? "en-EN" : "fr-FR", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit"
    });
};
var formatDate = function(date) {
    var language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "En";
    return new Date(date).toLocaleDateString(language === "En" ? "en-EN" : "fr-FR", {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric"
    });
};
var formatTime = function(date) {
    return new Date(date).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit"
    });
};

// EXTERNAL MODULE: ./src/utils/functions/language.function.ts
var language_function = __webpack_require__(7379);
;// CONCATENATED MODULE: ./src/utils/functions/string.functions.ts
var formatNumber = function(nbr) {
    return nbr.toString().padStart(2, "0");
};
var capitalizeFirstLetter = function(str) {
    return String.fromCharCode(str.charCodeAt(0) & 223) + str.slice(1);
};

// EXTERNAL MODULE: ./src/components/account/cancelEvent/index.module.scss
var cancelEvent_index_module = __webpack_require__(8911);
var cancelEvent_index_module_default = /*#__PURE__*/__webpack_require__.n(cancelEvent_index_module);
;// CONCATENATED MODULE: ./src/components/account/cancelEvent/index.tsx






var translations = {
    Fr: {
        confirm: "Confirmer",
        cancel: "Annuler",
        areYouSure: "Souhaitez-vous vraiment vous d\xe9sinscrire de cet \xe9v\xe8nement ?"
    },
    En: {
        confirm: "Confirm",
        cancel: "Cancel",
        areYouSure: "Do you want to cancel your attendance to this event ? "
    }
};
var CancelEventAttendance = function(param) {
    var handleCancelEvent = param.handleCancelEvent, cancelIsLoading = param.cancelIsLoading;
    var ref = (0,react.useState)(false), modalOpen = ref[0], setModalOpen = ref[1];
    var ref1 = (0,providers_language/* useLanguage */.ZK)(), lang = ref1.language;
    var handleOpenModal = function() {
        setModalOpen(true);
    };
    var handleCloseModal = function() {
        setModalOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                theme: "transparent-grey",
                onClick: handleOpenModal,
                children: lang === "Fr" ? "Annuler" : "Cancel"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_modal/* default */.Z, {
                open: modalOpen,
                onClose: handleCloseModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (cancelEvent_index_module_default()).container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: translations[lang].areYouSure
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (cancelEvent_index_module_default()).buttons,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                    disabled: cancelIsLoading,
                                    onClick: handleCloseModal,
                                    children: translations[lang].cancel
                                }),
                                "\xa0\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                    onClick: handleCancelEvent,
                                    isLoading: cancelIsLoading,
                                    children: translations[lang].confirm
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var cancelEvent = (CancelEventAttendance);

// EXTERNAL MODULE: ./src/components/account/guestButton/index.module.scss
var guestButton_index_module = __webpack_require__(9428);
var guestButton_index_module_default = /*#__PURE__*/__webpack_require__.n(guestButton_index_module);
;// CONCATENATED MODULE: ./src/components/account/guestButton/index.tsx





var GuestButton = function(param) {
    var isLoading = param.isLoading, guestNumber = param.guestNumber, hasBooking = param.hasBooking, guests = param.guests;
    var ref = (0,react.useState)(false), modalOpen = ref[0], setModalOpen = ref[1];
    var handleOpenModal = function() {
        setModalOpen(true);
    };
    var handleCloseModal = function() {
        setModalOpen(false);
    };
    // if there are no guests, don't show the button
    if (guestNumber === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                theme: "transparent-grey",
                isLoading: isLoading,
                uiOnly: !hasBooking,
                onClick: handleOpenModal,
                children: guestNumber
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_modal/* default */.Z, {
                open: modalOpen,
                onClose: handleCloseModal,
                showAnimation: "fade-in",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (guestButton_index_module_default()).modalContainer,
                    children: !guests || guests.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "No guests"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: guests === null || guests === void 0 ? void 0 : guests.map(function(guest) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    guest.firstname,
                                    " ",
                                    guest.lastname
                                ]
                            }, guest.id);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var guestButton = (GuestButton);

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./src/components/common/contextInput/index.tsx
var contextInput = __webpack_require__(779);
// EXTERNAL MODULE: ./src/utils/functions/general.functions.ts
var general_functions = __webpack_require__(337);
// EXTERNAL MODULE: ./src/components/account/guestForm/index.module.scss
var guestForm_index_module = __webpack_require__(2070);
var guestForm_index_module_default = /*#__PURE__*/__webpack_require__.n(guestForm_index_module);
;// CONCATENATED MODULE: ./src/components/account/guestForm/index.tsx














var GuestForm = function(param) {
    var type = param.type, eventName = param.eventName, currentGuests = param.currentGuests, allowedGuests = param.allowedGuests, handleSubmitForm = param.handleSubmitForm, isLoading = param.isLoading;
    var ref = (0,react.useState)(type === "invite"), disableButton = ref[0], setDisableButton = ref[1];
    var methods = (0,index_esm/* useForm */.cI)();
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var accountTexts = language === "En" ? en/* default.accountPage */.Z.accountPage : fr/* default.accountPage */.Z.accountPage;
    var handleSetDisableButton = function(e) {
        var _target = e.target, value = _target.value, name = _target.name;
        var index = +name.charAt(0);
        var nameToGet = name.includes("lastname") ? "firstname" : "lastname";
        var valueToGet = methods.getValues("".concat(index, ".").concat(nameToGet));
        if (value && !valueToGet || valueToGet && !value) {
            setDisableButton(true);
            return;
        }
        setDisableButton(false);
    };
    var handleSubmit = function(data) {
        var guests = (0,general_functions/* getObjectKeys */.Zt)(data).map(function(key) {
            return data[key];
        }).filter(function(guest) {
            return !!(guest.firstname && guest.lastname);
        });
        handleSubmitForm(guests);
    };
    var pluralizeGuest = allowedGuests > 1 ? "s" : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (guestForm_index_module_default()).guestsModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                children: [
                    "~",
                    eventName,
                    "~"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: accountTexts.invitation
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (guestForm_index_module_default()).guestsModalHead,
                children: "".concat(accountTexts.invitationText1, " ").concat(allowedGuests).concat(type === "invite" ? " suppl\xe9mentaire " : " ", " ").concat(accountTexts.person).concat(pluralizeGuest, " ").concat(accountTexts.invitationText2)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: function(e) {
                        e.preventDefault();
                        methods.handleSubmit(handleSubmit)();
                    },
                    className: (guestForm_index_module_default()).guestForm,
                    children: [
                        (0,_to_consumable_array/* default */.Z)(Array(allowedGuests)).map(function(_, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (guestForm_index_module_default()).guestLine,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            accountTexts.guest,
                                            " ",
                                            formatNumber(currentGuests + i + 1)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contextInput/* default */.Z, {
                                        name: "".concat(i, ".firstname"),
                                        label: "guest number ".concat(i),
                                        placeholder: accountTexts.firstname,
                                        size: 7,
                                        onChange: handleSetDisableButton
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contextInput/* default */.Z, {
                                        name: "".concat(i, ".lastname"),
                                        label: "guest number ".concat(i),
                                        placeholder: accountTexts.lastname,
                                        size: 7,
                                        onChange: handleSetDisableButton
                                    })
                                ]
                            }, i);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                            disabled: disableButton,
                            className: (guestForm_index_module_default()).submitButton,
                            isLoading: isLoading,
                            children: type === "book" ? accountTexts.confirmReservation : accountTexts.inviteGuests
                        })
                    ]
                })
            }))
        ]
    });
};
/* harmony default export */ var guestForm = (GuestForm);

// EXTERNAL MODULE: ./src/components/account/memberEvent/index.module.scss
var memberEvent_index_module = __webpack_require__(9652);
var memberEvent_index_module_default = /*#__PURE__*/__webpack_require__.n(memberEvent_index_module);
;// CONCATENATED MODULE: ./src/components/account/memberEvent/index.tsx




























var Event = function(param) {
    var event = param.event, _readonly = param.readonly, readonly = _readonly === void 0 ? true : _readonly, setCannotBookPopup = param.setCannotBookPopup;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(false), modalOpen = ref4[0], setModalOpen = ref4[1];
    var ref5 = (0,events/* useEvent */.z)(), setMyEvents = ref5.setMyEvents, myEvents = ref5.myEvents;
    var user = (0,auth/* useAuth */.aC)().user;
    var queryClient = (0,es.useQueryClient)();
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var accountTexts = language === "En" ? en/* default.accountPage */.Z.accountPage : fr/* default.accountPage */.Z.accountPage;
    // API Hooks
    var ref6 = (0,es.useMutation)(bookEventById, {
        onSuccess: function(res) {
            queryClient.invalidateQueries("events");
            setMyEvents(function(prev) {
                return (0,_to_consumable_array/* default */.Z)(prev).concat([
                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, event), {
                        booking: res
                    })
                ]);
            });
        }
    }), BookEventById = ref6.mutate, bookIsLoading = ref6.isLoading;
    var ref7 = (0,es.useMutation)(cancelEventById, {
        onSuccess: function() {
            queryClient.invalidateQueries("events");
            setMyEvents(function(prev) {
                return prev.filter(function(e) {
                    return e.id !== event.id;
                });
            });
        }
    }), CancelEventById = ref7.mutate, cancelIsLoading = ref7.isLoading;
    var ref8 = (0,es.useMutation)(inviteToEventById, {
        onSuccess: function(res) {
            queryClient.invalidateQueries("events");
            setMyEvents(function(prev) {
                return (0,_to_consumable_array/* default */.Z)(prev.filter(function(e) {
                    return e.id !== event.id;
                })).concat([
                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, event), {
                        booking: res
                    }), 
                ]);
            });
        }
    }), InviteToEventById = ref8.mutate, inviteIsLoading = ref8.isLoading;
    var ref9 = (0,es.useMutation)(uninviteFromEventById, {
        onSuccess: function(res) {
            queryClient.invalidateQueries("events");
            setMyEvents(function(prev) {
                return (0,_to_consumable_array/* default */.Z)(prev.filter(function(e) {
                    return e.id !== event.id;
                })).concat([
                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, event), {
                        booking: res
                    }), 
                ]);
            });
        }
    }), UninviteFromEventById = ref9.mutate, uninviteIsLoading = ref9.isLoading;
    var handleSwitchModalState = function(statut) {
        setModalOpen(statut);
    };
    var handleBookEvent = function(guests) {
        BookEventById({
            eventId: event.id,
            guests: guests
        });
        handleSwitchModalState(false);
    };
    var handleCancelEvent = function() {
        CancelEventById({
            eventId: event.id
        });
    };
    var handleInviteToEvent = function(guests) {
        InviteToEventById({
            eventId: event.id,
            guests: guests
        });
        handleSwitchModalState(false);
    };
    var ref10 = (0,react.useMemo)(function() {
        return [
            capitalizeFirstLetter(formatDate(event.dateFrom, language).split(".")[0]),
            formatTime(event.dateFrom),
            formatTime(event.dateTo), 
        ];
    }, [
        event.dateFrom,
        event.dateTo,
        language
    ]), eventDate = ref10[0], timeFrom = ref10[1], timeTo = ref10[2];
    var canBook = (0,react.useMemo)(function() {
        return myEvents.filter(function(param) {
            var dateFrom = param.dateFrom;
            return new Date(dateFrom) > new Date();
        }).length < 5;
    }, [
        myEvents
    ]);
    var handleBookClick = function() {
        if (event.type === eventEnums_type/* EventTypeEnum.NORMAL */.by.NORMAL) {
            if (!canBook) {
                setCannotBookPopup(true);
                ;
                return;
            }
            handleSwitchModalState(true);
        } else if (event.bookingLink) router_default().push(event.bookingLink);
    };
    var guestsList = (0,react.useMemo)(function() {
        var ref;
        if ((ref = event.booking) === null || ref === void 0 ? void 0 : ref.guests.length) {
            var ref1;
            return (ref1 = event.booking) === null || ref1 === void 0 ? void 0 : ref1.guests;
        }
        return [];
    }, [
        (ref = event.booking) === null || ref === void 0 ? void 0 : ref.guests
    ]);
    var allowedGuests = (user === null || user === void 0 ? void 0 : user.subscriptionType) === "MEMBER_PLUS" ? event.allowedGuestsPerParticipant * 2 : event.allowedGuestsPerParticipant;
    var _length;
    var bookingGuests = (_length = (ref1 = event.booking) === null || ref1 === void 0 ? void 0 : ref1.guests.length) !== null && _length !== void 0 ? _length : 0;
    var guestNumber = event.booking ? bookingGuests : allowedGuests;
    var remainingGuests = allowedGuests - bookingGuests;
    var subtitleAnimationStyles = (0,react.useMemo)(function() {
        var ref;
        var ref1;
        var eventSubtitlesLength = (ref1 = (ref = event["subtitle".concat(language)]) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0;
        return eventSubtitlesLength > 100 ? {
            animationDuration: "".concat(eventSubtitlesLength * 100, "ms"),
            textIndent: 0,
            paddingLeft: "100%"
        } : undefined;
    }, [
        event["subtitle".concat(language)]
    ]);
    var _titleEn;
    var eventTitle = language == "En" ? (_titleEn = event.titleEn) !== null && _titleEn !== void 0 ? _titleEn : event.title : event.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (memberEvent_index_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (memberEvent_index_module_default()).eventInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (memberEvent_index_module_default()).eventInfoLine,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (memberEvent_index_module_default()).date,
                                children: eventDate
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (memberEvent_index_module_default()).eventLocation,
                                style: {
                                    color: locations/* locationToColors */.zL[event.location]
                                },
                                children: locations/* locationToNames */.yt[event.location]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (memberEvent_index_module_default()).eventInfoLine,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (memberEvent_index_module_default()).time,
                                children: [
                                    timeFrom,
                                    " → ",
                                    timeTo
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (memberEvent_index_module_default()).eventTags,
                                children: event.tags.map(function(tag) {
                                    return (0,language_function/* getLanguage */.G)(tag, "name", language);
                                }).join(", ")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (memberEvent_index_module_default()).eventInfoLine,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (memberEvent_index_module_default()).buttonsContainer,
                            children: [
                                !event.booking ? /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                    theme: "white",
                                    onClick: handleBookClick,
                                    isLoading: bookIsLoading,
                                    children: event.isFull ? accountTexts.waitingList : accountTexts.book
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                    theme: event.booking.status === eventEnums_type/* BookingStatus.MAIN */.gn.MAIN ? "green" : "yellow",
                                    isLoading: cancelIsLoading,
                                    uiOnly: true,
                                    children: event.booking.status === eventEnums_type/* BookingStatus.MAIN */.gn.MAIN ? accountTexts.attending : accountTexts.waitlist
                                }),
                                event.booking && /*#__PURE__*/ (0,jsx_runtime.jsx)(cancelEvent, {
                                    handleCancelEvent: handleCancelEvent,
                                    cancelIsLoading: cancelIsLoading
                                }),
                                (canBook || ((ref2 = event.booking) === null || ref2 === void 0 ? void 0 : ref2.status)) && event.type === eventEnums_type/* EventTypeEnum.NORMAL */.by.NORMAL && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (memberEvent_index_module_default()).guestsButtonContainer,
                                    children: [
                                        event.booking ? guestNumber === 0 ? "" : guestNumber > 1 ? accountTexts.invitedGuests : accountTexts.invitedGuest : "".concat(accountTexts.invitation).concat(guestNumber > 1 ? "s" : ""),
                                        "\xa0\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(guestButton, {
                                            isLoading: inviteIsLoading || uninviteIsLoading || bookIsLoading,
                                            guestNumber: guestNumber,
                                            hasBooking: !!event.booking,
                                            guests: (ref3 = event.booking) === null || ref3 === void 0 ? void 0 : ref3.guests
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (memberEvent_index_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(img/* default */.Z, {
                    src: event.picturePath,
                    alt: eventTitle,
                    containerProps: {
                        className: (memberEvent_index_module_default()).imageContainer
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (memberEvent_index_module_default()).eventNameContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                    className: (memberEvent_index_module_default()).eventName,
                                    uiOnly: true,
                                    children: eventTitle
                                }),
                                event["subtitle".concat(language)] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (memberEvent_index_module_default()).eventSubtitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: subtitleAnimationStyles,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                            children: event["subtitle".concat(language)]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((memberEvent_index_module_default()).description, " no-scrollbar"),
                            children: event["description".concat(language)]
                        })
                    ]
                })
            }),
            !readonly && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (memberEvent_index_module_default()).invitedGuestsContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "textCenter",
                        children: guestsList.length <= 1 ? accountTexts.invitedGuest : accountTexts.invitedGuests
                    }),
                    guestsList.map(function(guest) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (memberEvent_index_module_default()).invitedGuestsLine,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (memberEvent_index_module_default()).guestName,
                                    children: "".concat(guest.firstname, " ").concat(guest.lastname)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function() {
                                        return UninviteFromEventById({
                                            eventId: event.id,
                                            id: guest.id
                                        });
                                    },
                                    className: (memberEvent_index_module_default()).removeGuest,
                                    children: "Supprimer"
                                })
                            ]
                        }, guest.id);
                    }),
                    remainingGuests > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                        theme: "transparent-grey",
                        onClick: function() {
                            return handleSwitchModalState(true);
                        },
                        isLoading: inviteIsLoading,
                        children: "Ajouter Invit\xe9 ".concat(formatNumber(remainingGuests))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_modal/* default */.Z, {
                open: modalOpen,
                onClose: function() {
                    return handleSwitchModalState(false);
                },
                showAnimation: "fade-in",
                children: !event.booking ? /*#__PURE__*/ (0,jsx_runtime.jsx)(guestForm, {
                    type: "book",
                    eventName: eventTitle,
                    currentGuests: 0,
                    allowedGuests: remainingGuests,
                    handleSubmitForm: handleBookEvent,
                    isLoading: bookIsLoading
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(guestForm, {
                    type: "invite",
                    eventName: eventTitle,
                    currentGuests: guestNumber,
                    allowedGuests: remainingGuests,
                    handleSubmitForm: handleInviteToEvent,
                    isLoading: inviteIsLoading
                })
            })
        ]
    });
};
/* harmony default export */ var memberEvent = (Event);

// EXTERNAL MODULE: ./src/components/account/agenda/index.module.scss
var agenda_index_module = __webpack_require__(8187);
var agenda_index_module_default = /*#__PURE__*/__webpack_require__.n(agenda_index_module);
;// CONCATENATED MODULE: ./src/components/account/agenda/index.tsx






var Agenda = function() {
    var myEvents = (0,events/* useEvent */.z)().myEvents;
    var ref = (0,react.useState)(false), cannotBookPopup = ref[0], setCannotBookPopup = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (agenda_index_module_default()).eventsGrid,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(account_cannotBookPopup, {
                open: cannotBookPopup,
                setOpen: setCannotBookPopup
            }),
            myEvents.sort(function(a, b) {
                return new Date(a.dateFrom) < new Date(b.dateFrom) ? -1 : 1;
            }).map(function(event) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(memberEvent, {
                    event: event,
                    readonly: false,
                    setCannotBookPopup: setCannotBookPopup
                }, event.id);
            })
        ]
    });
};
/* harmony default export */ var agenda = (Agenda);

// EXTERNAL MODULE: ./src/components/ui/loader/index.tsx
var loader = __webpack_require__(8408);
// EXTERNAL MODULE: ./src/components/account/birthday/index.module.scss
var birthday_index_module = __webpack_require__(7869);
var birthday_index_module_default = /*#__PURE__*/__webpack_require__.n(birthday_index_module);
;// CONCATENATED MODULE: ./src/components/account/birthday/index.tsx










var Birthday = function() {
    var user = (0,auth/* useAuth */.aC)().user;
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var ref = (0,react.useState)(), birthdayRange = ref[0], setBirthdayRange = ref[1];
    var book = language === "En" ? en/* default.accountPage.book */.Z.accountPage.book : fr/* default.accountPage.book */.Z.accountPage.book;
    var paragraph1 = language === "En" ? en/* default.accountPage.birthday.paragraph1 */.Z.accountPage.birthday.paragraph1 : fr/* default.accountPage.birthday.paragraph1 */.Z.accountPage.birthday.paragraph1;
    var paragraph2 = language === "En" ? en/* default.accountPage.birthday.paragraph2 */.Z.accountPage.birthday.paragraph2 : fr/* default.accountPage.birthday.paragraph2 */.Z.accountPage.birthday.paragraph2;
    var notifyText = language === "En" ? en/* default.accountPage.birthday.notifyText */.Z.accountPage.birthday.notifyText : fr/* default.accountPage.birthday.notifyText */.Z.accountPage.birthday.notifyText;
    var from = language === "En" ? en/* default.accountPage.from */.Z.accountPage.from : fr/* default.accountPage.from */.Z.accountPage.from;
    var to = language === "En" ? en/* default.accountPage.to */.Z.accountPage.to : fr/* default.accountPage.to */.Z.accountPage.to;
    (0,react.useEffect)(function() {
        if (user === null || user === void 0 ? void 0 : user.birthDate) {
            var birthdate = new Date(user === null || user === void 0 ? void 0 : user.birthDate);
            var oneWeekBefore = new Date();
            oneWeekBefore.setDate(birthdate.getDate() - 7);
            var oneWeekAfter = new Date();
            oneWeekAfter.setDate(birthdate.getDate() + 7);
            setBirthdayRange({
                oneWeekBefore: oneWeekBefore,
                oneWeekAfter: oneWeekAfter
            });
        }
    }, [
        user === null || user === void 0 ? void 0 : user.birthDate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "p-1 btg",
        children: birthdayRange ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: (birthday_index_module_default()).paragraph,
                    children: [
                        paragraph1,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        paragraph2,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        notifyText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: (birthday_index_module_default()).fromTo,
                    children: [
                        from,
                        "\xa0\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: formatSimpleDate(birthdayRange.oneWeekBefore, language)
                        }),
                        "\xa0\xa0",
                        to,
                        "\xa0\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: formatSimpleDate(birthdayRange.oneWeekAfter, language)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    target: "_blank",
                    rel: "noreferrer",
                    href: "https://bookings.zenchef.com/results?rid=352396&pid=1001",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                        className: (birthday_index_module_default()).button,
                        children: book
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* Loader */.a, {})
    });
};
/* harmony default export */ var birthday = (Birthday);

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(2920);
// EXTERNAL MODULE: ./src/api/users/updateUser.ts
var updateUser = __webpack_require__(9001);
// EXTERNAL MODULE: ./src/utils/constants/regex.ts
var regex = __webpack_require__(3036);
;// CONCATENATED MODULE: ./src/components/account/membership/fieldSets.ts
var personalInformationFieldsetsFr = [
    {
        legend: "Adresse",
        inputs: [
            {
                register: "phoneNumber",
                placeholder: "Num\xe9ro de t\xe9l\xe9phone",
                size: 14,
                disabled: true
            },
            {
                register: "address1",
                placeholder: "Adresse Ligne 1",
                disabled: true
            },
            {
                register: "address2",
                placeholder: "Adresse Ligne 2",
                disabled: true
            },
            {
                register: "city",
                placeholder: "Ville",
                disabled: true,
                size: 9
            },
            {
                register: "postalCode",
                placeholder: "postal code",
                disabled: true,
                size: 7
            }, 
        ]
    },
    {
        legend: "Occupation",
        inputs: [
            {
                register: "industry",
                placeholder: "Secteur",
                disabled: true,
                size: 9
            },
            {
                register: "jobTitle",
                placeholder: "Intitul\xe9 du poste",
                disabled: true,
                size: 7
            },
            {
                register: "companyName",
                placeholder: "Nom de l'entreprise",
                disabled: true
            },
            {
                register: "professionalEmail",
                placeholder: "Email professionnel (Si diff\xe9rent de l'email personnel)",
                disabled: true,
                size: 23
            },
            {
                register: "town",
                placeholder: "Ville",
                disabled: true,
                size: 9
            }, 
        ]
    }, 
];
var personalInformationFieldsets = [
    {
        legend: "Address",
        inputs: [
            {
                register: "phoneNumber",
                placeholder: "phone number",
                size: 14,
                disabled: true
            },
            {
                register: "address1",
                placeholder: "Adresse Line One",
                disabled: true
            },
            {
                register: "address2",
                placeholder: "Adresse Line Two",
                disabled: true
            },
            {
                register: "city",
                placeholder: "city",
                disabled: true,
                size: 9
            },
            {
                register: "postalCode",
                placeholder: "postal code",
                disabled: true,
                size: 7
            }, 
        ]
    },
    {
        legend: "Job",
        inputs: [
            {
                register: "industry",
                placeholder: "industry",
                disabled: true,
                size: 9
            },
            {
                register: "jobTitle",
                placeholder: "job title",
                disabled: true,
                size: 7
            },
            {
                register: "companyName",
                placeholder: "company name",
                disabled: true
            },
            {
                register: "professionalEmail",
                placeholder: "professional email (if different)",
                disabled: true,
                size: 23
            },
            {
                register: "town",
                placeholder: "town",
                disabled: true,
                size: 9
            }, 
        ]
    }, 
];
var paymentFieldsets = [
    {
        legend: "Moyen de paiement",
        inputs: [
            {
                register: "cardNumber",
                placeholder: "0000 0000 0000 0000",
                label: "Moyen de paiment",
                size: 17,
                disabled: true
            }, 
        ]
    }, 
];
var paymentFieldsetsEn = [
    {
        legend: "Card Number",
        inputs: [
            {
                register: "cardNumber",
                placeholder: "0000 0000 0000 0000",
                label: "Card Number",
                size: 17,
                disabled: true
            }, 
        ]
    }, 
];

// EXTERNAL MODULE: ./src/components/account/membership/form/index.module.scss
var form_index_module = __webpack_require__(4133);
var form_index_module_default = /*#__PURE__*/__webpack_require__.n(form_index_module);
;// CONCATENATED MODULE: ./src/components/account/membership/form/index.tsx










var SetDefaultValues = function(data, key) {
    if (key in data) {
        var val = data[key];
        if (!!val) return val;
    }
    return undefined;
};
var AccountMembershipForm = function(param) {
    var title = param.title, fieldSets = param.fieldSets, errorField = param.errorField, defaultValues = param.defaultValues, isLoading = param.isLoading, handleEmptyErrorField = param.handleEmptyErrorField, onSubmit = param.onSubmit, error = param.error, login = param.login;
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, setFocus = ref.setFocus;
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var accountTexts = language === "En" ? en/* default.accountPage */.Z.accountPage : fr/* default.accountPage */.Z.accountPage;
    (0,react.useEffect)(function() {
        if (errorField) {
            setFocus(errorField);
            if (handleEmptyErrorField) handleEmptyErrorField();
        }
    }, [
        errorField,
        handleEmptyErrorField,
        setFocus
    ]);
    var _label, _type, _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: "".concat((form_index_module_default()).accountMembershipForm, " ").concat(login ? (form_index_module_default()).noBorder : ""),
        onSubmit: function(e) {
            handleSubmit(onSubmit)(e);
        },
        children: [
            !login && /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: "small-title",
                children: title
            }),
            fieldSets.map(function(fieldSet, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                            children: fieldSet.legend
                        }),
                        fieldSet.inputs.map(function(input, j) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: (_label = input.label) !== null && _label !== void 0 ? _label : input.placeholder
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register(input.register)), {
                                        type: (_type = input.type) !== null && _type !== void 0 ? _type : "text",
                                        placeholder: input.placeholder,
                                        size: (_size = input.size) !== null && _size !== void 0 ? _size : 12,
                                        disabled: input.disabled,
                                        readOnly: input.disabled,
                                        defaultValue: defaultValues ? SetDefaultValues(defaultValues, input.register) : undefined
                                    }))
                                ]
                            }, j);
                        })
                    ]
                }, "".concat(title, "-fieldSet-").concat(i));
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: error
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                isLoading: isLoading,
                children: accountTexts.update
            })
        ]
    });
};
/* harmony default export */ var membership_form = (AccountMembershipForm);

// EXTERNAL MODULE: ./src/components/account/membership/index.module.scss
var membership_index_module = __webpack_require__(2023);
var membership_index_module_default = /*#__PURE__*/__webpack_require__.n(membership_index_module);
// EXTERNAL MODULE: ./src/components/account/membership/loginSection/loginSection.module.scss
var loginSection_module = __webpack_require__(4898);
var loginSection_module_default = /*#__PURE__*/__webpack_require__.n(loginSection_module);
// EXTERNAL MODULE: ./src/components/account/membership/loginSection/UpdatePassword/updatePassword.module.scss
var updatePassword_module = __webpack_require__(8518);
var updatePassword_module_default = /*#__PURE__*/__webpack_require__.n(updatePassword_module);
;// CONCATENATED MODULE: ./src/components/account/membership/loginSection/UpdatePassword/index.tsx











var UpdatePassword = function(param) {
    var handleClose = param.handleClose;
    var ref = (0,react.useState)(""), oldPassword = ref[0], setOldPassword = ref[1];
    var ref1 = (0,react.useState)([]), passwordRequirements = ref1[0], setPasswordRequirements = ref1[1];
    var ref2 = (0,react.useState)(false), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)(true), disabled = ref3[0], setDisabled = ref3[1];
    var ref4 = (0,react.useState)(""), newPassword = ref4[0], setNewPassword = ref4[1];
    var setUser = (0,auth/* useAuth */.aC)().setUser;
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var queryClient = (0,es.useQueryClient)();
    var loginFormTexts = language === "En" ? en/* default.accountPage.loginForm */.Z.accountPage.loginForm : fr/* default.accountPage.loginForm */.Z.accountPage.loginForm;
    var ref5 = (0,es.useMutation)(updateUser/* updateUser */.N, {
        onSuccess: function(res) {
            queryClient.invalidateQueries("user");
            react_toastify_esm/* toast.success */.Am.success(loginFormTexts.passwordUpdated);
            handleClose();
        },
        onError: function(err) {
            react_toastify_esm/* toast.error */.Am.error(loginFormTexts.passwordFailed);
        }
    }), isLoading = ref5.isLoading, mutate = ref5.mutate;
    var missingRequirements = [
        {
            regex: /[a-z]/,
            message: loginFormTexts.lowercase
        },
        {
            regex: /[A-Z]/,
            message: loginFormTexts.uppercase
        },
        {
            regex: /[0-9]/,
            message: loginFormTexts.number
        },
        {
            regex: /[^a-zA-Z0-9]/,
            message: loginFormTexts.specialCharacter
        },
        {
            regex: /.{8,}/,
            message: loginFormTexts.passwordLength
        }, 
    ];
    var checkPasswordStrength = function(value) {
        var nrw = missingRequirements.filter(function(param) {
            var regex = param.regex;
            return !regex.test(value);
        });
        if (nrw.length === 0) {
            return {
                isStrong: true,
                message: []
            };
        }
        return {
            isStrong: false,
            message: nrw.map(function(param) {
                var message = param.message;
                return message;
            })
        };
    };
    var handlePasswordConfirm = function(value) {
        if (value !== newPassword && passwordRequirements.length === 0 || value === "") {
            setError(true);
            setDisabled(true);
        } else {
            setDisabled(false);
            setError(false);
        }
    };
    var handleUpdatePassword = function() {
        // console.log("update password", oldPassword, newPassword);
        mutate({
            oldPassword: oldPassword,
            newPassword: newPassword
        });
    };
    (0,react.useEffect)(function() {
        setPasswordRequirements(checkPasswordStrength(newPassword).message);
    }, [
        newPassword
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (updatePassword_module_default()).updatePasswordContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("fieldset", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: (updatePassword_module_default()).label,
                        children: loginFormTexts.oldPassword
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "password",
                        placeholder: loginFormTexts.oldPassword,
                        size: 20,
                        onChange: function(e) {
                            return setOldPassword(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: (updatePassword_module_default()).label,
                        children: loginFormTexts.password
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "password",
                        placeholder: loginFormTexts.newPassword,
                        size: 20,
                        onChange: function(e) {
                            return setNewPassword(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "password",
                        placeholder: loginFormTexts.confirmNewPassword,
                        size: 20,
                        onChange: function(e) {
                            return handlePasswordConfirm(e.target.value);
                        }
                    }),
                    passwordRequirements && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: passwordRequirements.map(function(requirement, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (updatePassword_module_default()).error,
                                children: requirement
                            }, i);
                        })
                    }),
                    error && passwordRequirements.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (updatePassword_module_default()).error,
                        children: loginFormTexts.passwordsNotMatch
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                        onClick: handleUpdatePassword,
                        isLoading: isLoading,
                        disabled: disabled,
                        children: loginFormTexts.passwordUpdateFormButton
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var loginSection_UpdatePassword = (UpdatePassword);

;// CONCATENATED MODULE: ./src/components/account/membership/loginSection/index.tsx










var AccountLoginSection = function() {
    var ref = (0,react.useState)(false), modal = ref[0], setModal = ref[1];
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var user = (0,auth/* useAuth */.aC)().user;
    var loginFormTexts = language === "En" ? en/* default.accountPage.loginForm */.Z.accountPage.loginForm : fr/* default.accountPage.loginForm */.Z.accountPage.loginForm;
    var accountTexts = language === "En" ? en/* default.accountPage */.Z.accountPage : fr/* default.accountPage */.Z.accountPage;
    var handleModal = function() {
        setModal(!modal);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (loginSection_module_default()).loginSectionContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: "small-title",
                children: accountTexts.personalInformation
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                        children: loginFormTexts.legend
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: (loginSection_module_default()).label,
                                children: loginFormTexts.username
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "email",
                                placeholder: loginFormTexts.username,
                                size: 14,
                                disabled: true,
                                readOnly: true,
                                defaultValue: user === null || user === void 0 ? void 0 : user.username
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: (loginSection_module_default()).label,
                                children: loginFormTexts.password
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "password",
                                placeholder: "********",
                                size: 14,
                                disabled: true,
                                readOnly: true,
                                defaultValue: user === null || user === void 0 ? void 0 : user.username
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                onClick: handleModal,
                                style: {
                                    textTransform: "none"
                                },
                                children: loginFormTexts.update
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_modal/* default */.Z, {
                open: modal,
                onClose: function() {
                    setModal(false);
                },
                blur: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loginSection_UpdatePassword, {
                    handleClose: function() {
                        setModal(false);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var loginSection = (AccountLoginSection);

// EXTERNAL MODULE: ./node_modules/@stripe/react-stripe-js/dist/react-stripe.umd.js
var react_stripe_umd = __webpack_require__(6664);
// EXTERNAL MODULE: ./node_modules/@stripe/stripe-js/dist/stripe.esm.js
var stripe_esm = __webpack_require__(4465);
// EXTERNAL MODULE: ./src/api/stripe/getStatus.ts
var getStatus = __webpack_require__(1956);
// EXTERNAL MODULE: ./src/api/stripe/subscribe.ts
var subscribe = __webpack_require__(7292);
// EXTERNAL MODULE: ./src/utils/functions/dom.functions.ts
var dom_functions = __webpack_require__(4582);
// EXTERNAL MODULE: ./src/components/account/membership/paymentModal/index.module.scss
var paymentModal_index_module = __webpack_require__(8076);
var paymentModal_index_module_default = /*#__PURE__*/__webpack_require__.n(paymentModal_index_module);
;// CONCATENATED MODULE: ./src/components/account/membership/paymentModal/index.tsx













var PaymentForm = function(param) {
    var open = param.open, handleClose = param.handleClose;
    var queryClient = (0,es.useQueryClient)();
    var ref = (0,react.useState)("NONE"), cardStatus = ref[0], setCardStatus = ref[1];
    var ref1 = (0,react.useState)(""), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(false), submitted = ref2[0], setSubmitted = ref2[1];
    var ref3 = (0,react.useState)(false), canClose = ref3[0], setCanClose = ref3[1];
    var ref4 = (0,es.useMutation)(subscribe/* setupIntent */.o, {
        onSuccess: function(resp) {
            var ref, ref1, ref2, ref3;
            var url = resp === null || resp === void 0 ? void 0 : (ref = resp.next_action) === null || ref === void 0 ? void 0 : (ref1 = ref.redirect_to_url) === null || ref1 === void 0 ? void 0 : ref1.url;
            if (url) (0,dom_functions/* openUrl */.Y)(url);
            var sdk = resp === null || resp === void 0 ? void 0 : (ref2 = resp.next_action) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.use_stripe_sdk) === null || ref3 === void 0 ? void 0 : ref3.stripe_js;
            if (sdk) (0,dom_functions/* openUrl */.Y)(sdk);
            setCanClose(true);
        },
        onError: function() {
            setError("Une erreur est survenue, merci de r\xe9essayer.");
            setSubmitted(false);
        }
    }), mutateAsync = ref4.mutateAsync, isLoading = ref4.isLoading;
    var StripeElementOptions = (0,react.useMemo)(function() {
        return {
            style: {
                base: {
                    cursor: "pointer",
                    color: "#fff",
                    "::placeholder": {
                        color: "grey"
                    }
                },
                invalid: {
                    color: "#c23d4b"
                }
            }
        };
    }, []);
    (0,react.useEffect)(function() {
        if (cardStatus === "ACCEPTED") {
            if (canClose) {
                setTimeout(function() {
                    queryClient.invalidateQueries([
                        "user"
                    ]);
                }, 5000);
                handleClose();
            }
        }
        if (cardStatus === "REFUSED") setError("Votre paiement a \xe9t\xe9 refus\xe9, merci d'essayer \xe0 nouveau.");
    }, [
        cardStatus,
        canClose,
        queryClient,
        submitted,
        handleClose
    ]);
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            (0,getStatus/* getStripeCardStatus */.c)().then(function(res) {
                setCardStatus(res.stripeCardStatus);
            });
        }, 7000);
        return function() {
            return clearInterval(interval);
        };
    }, []);
    var stripe = (0,react_stripe_umd.useStripe)();
    var elements = (0,react_stripe_umd.useElements)();
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var cardNumberElement, paymentMethod;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(elements && stripe)) {
                            _ctx.next = 10;
                            break;
                        }
                        cardNumberElement = elements.getElement("cardNumber");
                        if (!cardNumberElement) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 5;
                        return stripe.createPaymentMethod({
                            type: "card",
                            card: cardNumberElement
                        });
                    case 5:
                        paymentMethod = _ctx.sent.paymentMethod;
                        if (!(paymentMethod && (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.card))) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 9;
                        return mutateAsync({
                            paymentMethod: paymentMethod.id,
                            stripeLast4Digit: paymentMethod.card.last4
                        });
                    case 9:
                        setSubmitted(true);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_modal/* default */.Z, {
        open: open,
        onClose: handleClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (paymentModal_index_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Veuillez entrer les d\xe9tails de paiement ci-dessous"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (paymentModal_index_module_default()).formContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardNumberElement, {
                            className: (paymentModal_index_module_default()).cardInput,
                            options: StripeElementOptions
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardExpiryElement, {
                            className: (paymentModal_index_module_default()).cardInput,
                            options: StripeElementOptions
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardCvcElement, {
                            className: (paymentModal_index_module_default()).cardInput,
                            options: StripeElementOptions
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                            isLoading: isLoading,
                            onClick: function(e) {
                                e.preventDefault();
                                handleSubmit();
                            },
                            children: "Confirmer"
                        }),
                        error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (paymentModal_index_module_default()).error,
                            children: error
                        })
                    ]
                })
            ]
        })
    });
};
var PaymentModal = function(param) {
    var open = param.open, handleClose = param.handleClose;
    var key = "pk_live_51LiGDYLUt3wCqmZfJ4IvXAU3BkQL4AFtF2npOIOv6gt5Lk5Du2ccc2BUj8pwbVDpyFxiYLUDmu5ISdEpovfWieQG003qK62SVv";
    var stripePromise = (0,stripe_esm/* loadStripe */.J)(key !== null && key !== void 0 ? key : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.Elements, {
        stripe: stripePromise,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm, {
            open: open,
            handleClose: handleClose
        })
    });
};
/* harmony default export */ var paymentModal = (PaymentModal);

;// CONCATENATED MODULE: ./src/api/stripe/renew.ts



var renewSubscription = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(renew) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,axios/* sendRequest */.wG)({
                        method: "post",
                        url: "/subscription/renew-subscription",
                        data: {
                            renew: renew
                        }
                    });
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function renewSubscription(renew) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/components/account/membership/subscriptionForm/index.module.scss
var subscriptionForm_index_module = __webpack_require__(2374);
var subscriptionForm_index_module_default = /*#__PURE__*/__webpack_require__.n(subscriptionForm_index_module);
;// CONCATENATED MODULE: ./src/components/account/membership/subscriptionForm/index.tsx



















var Input = function(param) {
    var label = param.label, name = param.name, uncheckedText = param.uncheckedText, checkedText = param.checkedText, defaultChecked = param.defaultChecked, _readonly = param.readonly, readonly = _readonly === void 0 ? false : _readonly, onchange = param.onchange, children = param.children;
    var register = (0,index_esm/* useFormContext */.Gc)().register;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (subscriptionForm_index_module_default()).inputContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                children: label
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: uncheckedText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (subscriptionForm_index_module_default()).input,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register(name)), {
                                type: "checkbox",
                                defaultChecked: defaultChecked,
                                readOnly: readonly,
                                disabled: readonly,
                                onChange: onchange
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: checkedText
                    })
                ]
            })
        ]
    });
};
var SubscriptionForm = function() {
    var ref = (0,react.useState)(false), modalOpen = ref[0], setModalOpen = ref[1];
    var methods = (0,index_esm/* useForm */.cI)();
    var user = (0,auth/* useAuth */.aC)().user;
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var accountTexts = language === "En" ? en/* default.accountPage */.Z.accountPage : fr/* default.accountPage */.Z.accountPage;
    var queryClient = (0,es.useQueryClient)();
    var mutateAsync = (0,es.useMutation)(renewSubscription).mutateAsync;
    var ref1 = (0,es.useMutation)(updateUser/* updateUser */.N, {
        onSuccess: function() {
            queryClient.invalidateQueries("user");
        }
    }), changeSubscriptionFrequency = ref1.mutate;
    if (!user) return null;
    var freeAccessUntil = user.freeAccessUntil, subscription = user.subscription;
    var monthlySubscription = (user === null || user === void 0 ? void 0 : user.subscriptionFrequency) === subscription_types/* SubscriptionFrequencyType.MONTHLY */.A.MONTHLY;
    var handleSubscriptionFrequencyChange = function(e) {
        changeSubscriptionFrequency({
            subscriptionFrequency: e.target.checked ? subscription_types/* SubscriptionFrequencyType.MONTHLY */.A.MONTHLY : subscription_types/* SubscriptionFrequencyType.YEARLY */.A.YEARLY
        });
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (subscription) {
                            _ctx.next = 3;
                            break;
                        }
                        setModalOpen(true);
                        return _ctx.abrupt("return");
                    case 3:
                        if (!(data.automaticRenewal !== undefined)) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 6;
                        return mutateAsync(data.automaticRenewal);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: (subscriptionForm_index_module_default()).form,
                    onSubmit: function(e) {
                        e.preventDefault();
                        methods.handleSubmit(handleSubmit)();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            children: accountTexts.mySubscription
                        }),
                        !subscription && !!freeAccessUntil && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "Acc\xe8s gratuit jusqu'au",
                                " ",
                                new Date(freeAccessUntil).toLocaleDateString("fr")
                            ]
                        }),
                        !subscription && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                            name: "subscriptionFrequency",
                            uncheckedText: "Paiment annuel",
                            checkedText: "Paiment mensuel",
                            label: "Paiement",
                            defaultChecked: monthlySubscription,
                            readonly: !!subscription,
                            onchange: handleSubscriptionFrequencyChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: (0,general_functions/* getPaymentText */.YZ)(user, language)
                        }),
                        !subscription && /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                            children: language == "En" ? "Activate my subscription" : "Activer mon abonnement"
                        })
                    ]
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(paymentModal, {
                open: modalOpen,
                handleClose: function() {
                    setModalOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ var subscriptionForm = (SubscriptionForm);

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(993);
// EXTERNAL MODULE: ./src/components/account/membership/subscriptionRenewal/index.module.scss
var subscriptionRenewal_index_module = __webpack_require__(2861);
var subscriptionRenewal_index_module_default = /*#__PURE__*/__webpack_require__.n(subscriptionRenewal_index_module);
;// CONCATENATED MODULE: ./src/components/account/membership/subscriptionRenewal/index.tsx











var SubscriptionRenewal = function(param) {
    var renew = param.renew, successNotification = param.successNotification;
    var ref = (0,react.useState)(false), modalOpen = ref[0], setModalOpen = ref[1];
    var ref1 = (0,react.useState)(""), error = ref1[0], setError = ref1[1];
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var accountTexts = language === "En" ? en/* default.accountPage */.Z.accountPage : fr/* default.accountPage */.Z.accountPage;
    var queryClient = (0,es.useQueryClient)();
    var handleCloseModal = function() {
        setModalOpen(false);
    };
    var ref2 = (0,es.useMutation)(renewSubscription, {
        onSuccess: function() {
            successNotification();
            queryClient.invalidateQueries("user");
            handleCloseModal();
            ;
        },
        onError: function() {
            setError("Une erreur est survenue, veuillez r\xe9essayer.");
        }
    }), mutate = ref2.mutate, isLoading = ref2.isLoading;
    var handleUpdateRenewal = function() {
        // it is the opposite of the current value
        mutate(!renew);
    };
    var buttonText = renew ? accountTexts.cancelSubscription : accountTexts.reactivateMySubscription;
    var modalText = renew ? "\xcates-vous s\xfbr de vouloir annuler votre abonnement ?" : "Souhaitez-vous r\xe9activer votre abonnement ?";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (subscriptionRenewal_index_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                onClick: function() {
                    return setModalOpen(true);
                },
                children: buttonText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_modal/* default */.Z, {
                open: modalOpen,
                onClose: handleCloseModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (subscriptionRenewal_index_module_default()).modalContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: modalText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (subscriptionRenewal_index_module_default()).buttonsContainer,
                            children: [
                                !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                    onClick: handleCloseModal,
                                    children: "Non"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                    onClick: handleUpdateRenewal,
                                    isLoading: isLoading,
                                    children: "Oui"
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (subscriptionRenewal_index_module_default()).error,
                            children: error
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var subscriptionRenewal = (SubscriptionRenewal);

;// CONCATENATED MODULE: ./src/components/account/membership/index.tsx



















var clearEmptyFields = function(data) {
    for(var key in data){
        var val = data[key];
        if (!val) delete data[key];
    }
};
var clearUserUnchangedFields = function(data, user) {
    if (!user) return;
    for(var key in data){
        if (key in user) {
            var defVal = "".concat(user[key]);
            var val = "".concat(data[key]);
            if (val === defVal) delete data[key];
        }
    }
};
var AccountMembership = function() {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(), personalInformationErrorField = ref3[0], setPersonalInformationErrorField = ref3[1];
    var ref4 = (0,react.useState)(), paymentErrorField = ref4[0], setPaymentErrorField = ref4[1];
    var ref5 = (0,react.useState)(false), modalOpen = ref5[0], setModalOpen = ref5[1];
    var ref6 = (0,auth/* useAuth */.aC)(), user = ref6.user, setUser = ref6.setUser;
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var accountTexts = language === "En" ? en/* default.accountPage */.Z.accountPage : fr/* default.accountPage */.Z.accountPage;
    var successNotification = function() {
        return react_toastify_esm/* toast.success */.Am.success("Votre abonnement a bien \xe9t\xe9 r\xe9sili\xe9", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
        });
    };
    var userHasSubscription = !!user && !!user.subscription;
    var ref7 = (0,es.useMutation)(updateUser/* updateUser */.N, {
        onSuccess: function(res) {
            setUser(res);
        }
    }), isUpdateUserLoading = ref7.isLoading, updateUserMutation = ref7.mutate;
    var handleCloseModal = function() {
        setModalOpen(false);
    };
    var handleEmptyPersonalInformationErrorField = function() {
        setPersonalInformationErrorField(undefined);
    };
    var handleEmptysetPaymentErrorField = function() {
        setPaymentErrorField(undefined);
    };
    var onSubmitPersonalInformation = function(data) {
        clearEmptyFields(data);
        clearUserUnchangedFields(data, user);
        if ((0,general_functions/* isEmptyObject */.Qr)(data)) return;
        if (data.email && !regex/* emailRegex.test */.H.test(data.email)) {
            setPersonalInformationErrorField("email");
            return;
        }
        if (data.password) {
            if (!regex/* passwordRegex.test */.B.test(data.password)) {
                setPersonalInformationErrorField("password");
                return;
            }
            if (data.password !== data.confirmPassword) {
                setPersonalInformationErrorField("confirmPassword");
                return;
            }
        }
        updateUserMutation(data);
    };
    var onSubmitPayment = function() {
        setModalOpen(true);
    };
    var ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            (user === null || user === void 0 ? void 0 : (ref = user.subscription) === null || ref === void 0 ? void 0 : ref.renew) === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(subscriptionRenewal, {
                renew: false,
                successNotification: successNotification
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(subscriptionForm, {}),
            userHasSubscription && /*#__PURE__*/ (0,jsx_runtime.jsx)(membership_form, {
                title: accountTexts.payment,
                fieldSets: language === "En" ? paymentFieldsetsEn : paymentFieldsets,
                errorField: paymentErrorField,
                error: user.stripeCardStatus === "REFUSED" ? "Moyen de paiement refus\xe9" : undefined,
                defaultValues: {
                    cardNumber: "**** **** **** ".concat((ref8 = user === null || user === void 0 ? void 0 : user.stripeLast4Digit) !== null && ref8 !== void 0 ? ref8 : "****")
                },
                onSubmit: onSubmitPayment,
                handleEmptyErrorField: handleEmptysetPaymentErrorField
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(loginSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(membership_form, {
                title: accountTexts.personalInformation,
                fieldSets: language === "Fr" ? personalInformationFieldsetsFr : personalInformationFieldsets,
                errorField: personalInformationErrorField,
                defaultValues: user,
                isLoading: isUpdateUserLoading,
                submitButtonText: (user === null || user === void 0 ? void 0 : (ref1 = user.subscription) === null || ref1 === void 0 ? void 0 : ref1.subscriptionStatus) === subscription_types/* SubscriptionStatus.ACTIVE */.y.ACTIVE ? "Sauvegarder" : "Activer mon abonnement",
                onSubmit: onSubmitPersonalInformation,
                handleEmptyErrorField: handleEmptyPersonalInformationErrorField,
                login: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (membership_index_module_default()).modifyOtherInformation,
                children: [
                    accountTexts.toChangeInformation,
                    "→",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:contact@lesilencio.com",
                        children: "contact@lesilencio.com"
                    })
                ]
            }),
            (user === null || user === void 0 ? void 0 : (ref2 = user.subscription) === null || ref2 === void 0 ? void 0 : ref2.renew) && /*#__PURE__*/ (0,jsx_runtime.jsx)(subscriptionRenewal, {
                renew: true,
                successNotification: successNotification
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(paymentModal, {
                open: modalOpen,
                handleClose: handleCloseModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                newestOnTop: false,
                closeOnClick: true,
                rtl: false,
                pauseOnFocusLoss: true,
                draggable: true,
                pauseOnHover: true
            })
        ]
    });
};
/* harmony default export */ var membership = (AccountMembership);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-indiana-drag-scroll/dist/index.es.js
var index_es = __webpack_require__(804);
// EXTERNAL MODULE: ./node_modules/react-calendar/dist/Calendar.css
var Calendar = __webpack_require__(9318);
// EXTERNAL MODULE: ./node_modules/react-calendar/dist/esm/index.js + 28 modules
var esm = __webpack_require__(6876);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(9647);
// EXTERNAL MODULE: ./src/components/calendar/calendar.module.scss
var calendar_module = __webpack_require__(9392);
var calendar_module_default = /*#__PURE__*/__webpack_require__.n(calendar_module);
;// CONCATENATED MODULE: ./src/components/calendar/index.tsx





var calendar_Calendar = function(param) {
    var value = param.value, handleCloseCalendar = param.handleCloseCalendar, handleSetDateFilter = param.handleSetDateFilter;
    var onChange = function(e) {
        var dateFrom = e[0];
        var dateTo = e[1];
        if (dateFrom && dateTo) {
            handleSetDateFilter(dateFrom, dateTo);
            handleCloseCalendar();
        }
    };
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (calendar_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
            className: (calendar_module_default()).calendar,
            tileClassName: (calendar_module_default()).day,
            onChange: onChange,
            selectRange: true,
            nextLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiArrowRight */.Rgz, {}),
            prevLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiArrowLeft */.Ao2, {}),
            view: "month",
            value: [
                (ref = value === null || value === void 0 ? void 0 : value.dateFrom) !== null && ref !== void 0 ? ref : null,
                (ref1 = value === null || value === void 0 ? void 0 : value.dateTo) !== null && ref1 !== void 0 ? ref1 : null
            ],
            defaultActiveStartDate: new Date()
        })
    });
};
/* harmony default export */ var calendar = (calendar_Calendar);

// EXTERNAL MODULE: ./src/components/ui/fullFilter/index.tsx
var ui_fullFilter = __webpack_require__(3218);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/utils/functions/events.functions.ts

var isBetweenDates = function(event, dateFrom, dateTo) {
    if (!dateFrom && !dateTo) return true;
    var eventDateFrom = moment_default()(event.dateFrom).isAfter(dateFrom);
    var eventDateTo = moment_default()(event.dateFrom).isBefore(dateTo);
    return eventDateFrom && eventDateTo;
};
var getFilteredEvents = function(events, fullFilter) {
    return events.filter(function(event) {
        var ref, ref1;
        return (fullFilter.locations.length === 0 || fullFilter.locations.includes(event.location)) && (fullFilter.tags.length === 0 || fullFilter.tags.map(function(param) {
            var id = param.id;
            return id;
        }).some(function(id) {
            return event.tags.map(function(param) {
                var _$id = param.id;
                return _$id;
            }).includes(id);
        })) && (!fullFilter.dates || isBetweenDates(event, moment_default()((ref = fullFilter.dates) === null || ref === void 0 ? void 0 : ref.dateFrom), moment_default()((ref1 = fullFilter.dates) === null || ref1 === void 0 ? void 0 : ref1.dateTo)));
    });
};

// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(6703);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(615);
// EXTERNAL MODULE: ./node_modules/text-clipper/dist/index.js
var dist = __webpack_require__(5104);
// EXTERNAL MODULE: ./src/components/common/spacer/index.tsx
var spacer = __webpack_require__(7824);
// EXTERNAL MODULE: ./src/components/account/highlightedEvent/index.module.scss
var highlightedEvent_index_module = __webpack_require__(3943);
var highlightedEvent_index_module_default = /*#__PURE__*/__webpack_require__.n(highlightedEvent_index_module);
;// CONCATENATED MODULE: ./src/components/account/highlightedEvent/index.tsx
























var HighlightedEvent = function(param) {
    var event = param.event, setCannotBookPopup = param.setCannotBookPopup;
    var ref, ref1;
    var ref2 = (0,react.useState)(false), readMoreClicked = ref2[0], setReadMoreClicked = ref2[1];
    var ref3 = (0,react.useState)(false), modalOpen = ref3[0], setModalOpen = ref3[1];
    var user = (0,auth/* useAuth */.aC)().user;
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var ref4 = (0,events/* useEvent */.z)(), setMyEvents = ref4.setMyEvents, myEvents = ref4.myEvents;
    var queryClient = (0,es.useQueryClient)();
    var accountTexts = language === "En" ? en/* default.accountPage */.Z.accountPage : fr/* default.accountPage */.Z.accountPage;
    var waitlist = language === "En" ? en/* default.accountPage.waitlist */.Z.accountPage.waitlist : fr/* default.accountPage.waitlist */.Z.accountPage.waitlist;
    var attending = language === "En" ? en/* default.accountPage.attending */.Z.accountPage.attending : fr/* default.accountPage.attending */.Z.accountPage.attending;
    var close = language === "En" ? en/* default.accountPage.close */.Z.accountPage.close : fr/* default.accountPage.close */.Z.accountPage.close;
    var readMore = language === "En" ? en/* default.accountPage.readMore */.Z.accountPage.readMore : fr/* default.accountPage.readMore */.Z.accountPage.readMore;
    var ref5 = (0,es.useMutation)(bookEventById, {
        onSuccess: function(res) {
            queryClient.invalidateQueries("events");
            setMyEvents((0,_to_consumable_array/* default */.Z)(myEvents).concat([
                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, event), {
                    booking: res
                })
            ]));
        }
    }), BookEventById = ref5.mutate, isLoading = ref5.isLoading;
    var canBook = (0,react.useMemo)(function() {
        return myEvents.filter(function(param) {
            var dateFrom = param.dateFrom;
            return new Date(dateFrom) > new Date();
        }).length < 5;
    }, [
        myEvents
    ]);
    var handleSwitchModalState = function(status) {
        setModalOpen(status);
    };
    var ref6 = (0,react.useMemo)(function() {
        return [
            formatDate(event.dateFrom, language),
            formatTime(event.dateFrom),
            formatTime(event.dateTo), 
        ];
    }, [
        event.dateFrom,
        event.dateTo,
        language
    ]), eventDate = ref6[0], timeFrom = ref6[1], timeTo = ref6[2];
    var allowedGuests = (user === null || user === void 0 ? void 0 : user.subscriptionType) === "MEMBER_PLUS" ? event.allowedGuestsPerParticipant * 2 : event.allowedGuestsPerParticipant;
    var _length;
    var bookingGuests = (_length = (ref = event.booking) === null || ref === void 0 ? void 0 : ref.guests.length) !== null && _length !== void 0 ? _length : 0;
    var guestNumber = event.booking ? bookingGuests : allowedGuests;
    var handleReadMoreClick = function() {
        setReadMoreClicked(!readMoreClicked);
    };
    var handleBookEvent = function(guests) {
        BookEventById({
            eventId: event.id,
            guests: guests
        });
        handleSwitchModalState(false);
    };
    var handleBookClick = (0,react.useCallback)(function() {
        if (event.type === eventEnums_type/* EventTypeEnum.NORMAL */.by.NORMAL) {
            if (!canBook) {
                setCannotBookPopup(true);
                ;
                return;
            }
            handleSwitchModalState(true);
        } else if (event.bookingLink) router_default().push(event.bookingLink);
    }, [
        canBook,
        event.bookingLink,
        event.type,
        handleSwitchModalState
    ]);
    var _highlightPicturePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (highlightedEvent_index_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (highlightedEvent_index_module_default()).eventInfoContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (highlightedEvent_index_module_default()).eventInfo,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (highlightedEvent_index_module_default()).eventInfoLine + " " + (highlightedEvent_index_module_default()).reverse,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (highlightedEvent_index_module_default()).eventName,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                            children: event.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (highlightedEvent_index_module_default()).eventLocationTags,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (highlightedEvent_index_module_default()).eventLocation,
                                                style: {
                                                    color: "".concat(locations/* locationToColors */.zL[event.location])
                                                },
                                                children: locations/* locationToNames */.yt[event.location]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (highlightedEvent_index_module_default()).eventTags,
                                                children: event.tags.map(function(tag) {
                                                    return (0,language_function/* getLanguage */.G)(tag, "name", language);
                                                }).join(", ")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (highlightedEvent_index_module_default()).spacer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {
                                    height: "10px",
                                    width: "100%"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (highlightedEvent_index_module_default()).eventInfoLine,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (highlightedEvent_index_module_default()).dateTime,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (highlightedEvent_index_module_default()).date,
                                                children: eventDate
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (highlightedEvent_index_module_default()).time,
                                                children: [
                                                    timeFrom,
                                                    " → ",
                                                    timeTo
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (highlightedEvent_index_module_default()).bookGuests,
                                        children: [
                                            !event.booking ? /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                                theme: "white",
                                                onClick: handleBookClick,
                                                isLoading: isLoading,
                                                children: event.isFull ? accountTexts.waitingList : accountTexts.book
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                                theme: event.booking.status === eventEnums_type/* BookingStatus.MAIN */.gn.MAIN ? "green" : "yellow",
                                                isLoading: isLoading,
                                                uiOnly: true,
                                                children: event.booking.status === eventEnums_type/* BookingStatus.MAIN */.gn.MAIN ? attending : waitlist
                                            }),
                                            (canBook || ((ref1 = event.booking) === null || ref1 === void 0 ? void 0 : ref1.status)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (highlightedEvent_index_module_default()).guestsButtonContainer,
                                                children: [
                                                    event.booking ? guestNumber > 1 ? accountTexts.invitedGuests : accountTexts.invitedGuest : "".concat(accountTexts.invitation).concat(guestNumber > 1 ? "s" : ""),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                                        theme: "transparent-grey",
                                                        isLoading: isLoading,
                                                        children: guestNumber
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (highlightedEvent_index_module_default()).eventInfoDescription,
                        children: [
                            !readMoreClicked ? (0,dist/* default */.Z)(event.descriptionEn, 300) : event.descriptionEn,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: handleReadMoreClick,
                                className: (highlightedEvent_index_module_default()).readMore,
                                children: readMoreClicked ? close : readMore
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(img/* default */.Z, {
                src: (_highlightPicturePath = event.highlightPicturePath) !== null && _highlightPicturePath !== void 0 ? _highlightPicturePath : event.picturePath,
                alt: event.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (highlightedEvent_index_module_default()).eventNameMobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                    uiOnly: true,
                    children: event.title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_modal/* default */.Z, {
                open: modalOpen,
                onClose: function() {
                    return handleSwitchModalState(false);
                },
                showAnimation: "fade-in",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(guestForm, {
                    type: "book",
                    eventName: event.title,
                    currentGuests: 0,
                    allowedGuests: guestNumber,
                    handleSubmitForm: handleBookEvent,
                    isLoading: isLoading
                })
            })
        ]
    });
};
/* harmony default export */ var highlightedEvent = (/*#__PURE__*/(0,react.memo)(HighlightedEvent));

// EXTERNAL MODULE: ./src/components/account/highlightsCarousel/index.module.scss
var highlightsCarousel_index_module = __webpack_require__(8581);
var highlightsCarousel_index_module_default = /*#__PURE__*/__webpack_require__.n(highlightsCarousel_index_module);
;// CONCATENATED MODULE: ./src/components/account/highlightsCarousel/index.tsx







var HighlightsCarousel = function(param) {
    var events = param.events;
    var ref = (0,react.useState)(false), cannotBookPopup = ref[0], setCannotBookPopup = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(account_cannotBookPopup, {
                open: cannotBookPopup,
                setOpen: setCannotBookPopup
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, {
                className: (highlightsCarousel_index_module_default()).carouselContainer,
                showStatus: false,
                children: events.map(function(event) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(highlightedEvent, {
                        event: event,
                        setCannotBookPopup: setCannotBookPopup
                    }, event.id);
                })
            })
        ]
    });
};
/* harmony default export */ var highlightsCarousel = (HighlightsCarousel);

// EXTERNAL MODULE: ./src/hooks/grabToScroll.ts
var grabToScroll = __webpack_require__(3722);
;// CONCATENATED MODULE: ./src/utils/constants/days.ts
var filterDays = [
    {
        textFr: "L",
        textEn: "M",
        value: 1
    },
    {
        textFr: "M",
        textEn: "T",
        value: 2
    },
    {
        textFr: "M",
        textEn: "W",
        value: 3
    },
    {
        textFr: "J",
        textEn: "T",
        value: 4
    },
    {
        textFr: "V",
        textEn: "F",
        value: 5
    },
    {
        textFr: "S",
        textEn: "S",
        value: 6
    },
    {
        textFr: "D",
        textEn: "S",
        value: 7
    }, 
];

// EXTERNAL MODULE: ./src/components/account/weekScroller/index.module.scss
var weekScroller_index_module = __webpack_require__(7076);
var weekScroller_index_module_default = /*#__PURE__*/__webpack_require__.n(weekScroller_index_module);
;// CONCATENATED MODULE: ./src/components/account/weekScroller/index.tsx

var _this = undefined;











var WeekScroller = function(param) {
    var weekHeader = param.weekHeader, data = param.data;
    var scrollContainerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), cannotBookPopup = ref[0], setCannotBookPopup = ref[1];
    var ref1 = (0,react.useState)([]), days = ref1[0], setDays = ref1[1];
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var accountTexts = language === "En" ? en/* default.accountPage */.Z.accountPage : fr/* default.accountPage */.Z.accountPage;
    (0,grabToScroll/* useGrabToScroll */.f)(scrollContainerRef, {
        grabCursor: true
    });
    var displayWeekEvents = (0,react.useMemo)(function() {
        return data.filter(function(el) {
            var dateFrom = new Date(el.dateFrom);
            var dateTo = new Date(el.dateTo);
            return days.length === 0 || days.includes(dateFrom.getDay()) || days.includes(dateTo.getDay());
        }).sort(function(a, b) {
            return new Date(a.dateFrom) < new Date(b.dateFrom) ? -1 : 1;
        }).map(function(event) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(memberEvent, {
                event: event,
                readonly: true,
                setCannotBookPopup: setCannotBookPopup
            }, event.id);
        });
    }, [
        data,
        days
    ]);
    var handleSetDay = (0,react.useCallback)(function(day) {
        setDays(function(prev) {
            if (prev.includes(day)) {
                return prev.filter(function(el) {
                    return el !== day;
                });
            }
            return (0,_to_consumable_array/* default */.Z)(prev).concat([
                day
            ]);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (weekScroller_index_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(account_cannotBookPopup, {
                open: cannotBookPopup,
                setOpen: setCannotBookPopup
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (weekScroller_index_module_default()).weekInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (weekScroller_index_module_default()).weekPeriod,
                        children: weekHeader
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "".concat(formatNumber(data.length), " ").concat(accountTexts.event).concat(data.length > 1 ? "s" : "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (weekScroller_index_module_default()).weekDays,
                        children: filterDays.map(function(param) {
                            var value = param.value, textEn = param.textEn, textFr = param.textFr;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: handleSetDay.bind(_this, value),
                                className: days.includes(value) ? (weekScroller_index_module_default()).active : undefined,
                                children: language === "En" ? textEn : textFr
                            }, value);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (weekScroller_index_module_default()).weekEvents,
                ref: scrollContainerRef,
                children: displayWeekEvents
            })
        ]
    });
};
/* harmony default export */ var weekScroller = (WeekScroller);

// EXTERNAL MODULE: ./src/components/account/programme/index.module.scss
var programme_index_module = __webpack_require__(6095);
var programme_index_module_default = /*#__PURE__*/__webpack_require__.n(programme_index_module);
;// CONCATENATED MODULE: ./src/components/account/programme/utils/index.ts


moment_default().updateLocale("en", {
    week: {
        dow: 1
    }
});
var orderByWeek = function(events) {
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var mappedEvents = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var event = _step.value;
            var dateFrom = moment_default()(event.dateFrom);
            var week = dateFrom.week();
            var year = dateFrom.year();
            var monday = dateFrom.startOf("day").clone().weekday(0);
            var sunday = dateFrom.startOf("day").clone().weekday(6);
            var index = "".concat(year, "-").concat(week);
            if (mappedEvents[index]) {
                mappedEvents[index].data.push(event);
            } else {
                mappedEvents[index] = {
                    header: language === "En" ? "".concat(monday.format("MMM"), " ").concat(monday.date(), " → ").concat(sunday.format("MMM"), " ").concat(sunday.date(), " ") : "".concat(monday.date(), " ").concat(monday.format("MMM"), " → ").concat(sunday.date(), " ").concat(sunday.format("MMM")),
                    data: [
                        event
                    ],
                    date: new Date(event.dateFrom)
                };
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mappedEvents;
};

;// CONCATENATED MODULE: ./src/components/account/programme/index.tsx





















var Programme = function(param) {
    var events = param.events, tags = param.tags;
    var ref, ref1;
    var ref2 = (0,react.useState)({
        locations: [],
        capacities: [],
        tags: []
    }), fullFilter = ref2[0], setFullFilter = ref2[1];
    var ref3 = (0,react.useState)(false), open = ref3[0], setOpen = ref3[1];
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var accountTexts = language === "En" ? en/* default.accountPage */.Z.accountPage : fr/* default.accountPage */.Z.accountPage;
    var filteredEvents = (0,react.useMemo)(function() {
        return orderByWeek(getFilteredEvents(events, fullFilter));
    }, [
        events,
        fullFilter
    ]);
    var highlightedEvents = (0,react.useMemo)(function() {
        return events.filter(function(el) {
            return el.highlighted;
        });
    }, [
        events
    ]);
    var showHighlights = (0,react.useMemo)(function() {
        var ref, ref1;
        return !fullFilter.locations.length && !fullFilter.tags.length && !((ref = fullFilter.dates) === null || ref === void 0 ? void 0 : ref.dateFrom) && !((ref1 = fullFilter.dates) === null || ref1 === void 0 ? void 0 : ref1.dateTo) && highlightedEvents.length;
    }, [
        fullFilter,
        highlightedEvents
    ]);
    var handleResetFilter = function() {
        setFullFilter({
            locations: [],
            capacities: [],
            tags: []
        });
    };
    var handleSetLocationFilter = function(filterName) {
        setFullFilter(function(prev) {
            var locations = prev.locations.includes(filterName) ? prev.locations.filter(function(locations) {
                return locations !== filterName;
            }) : (0,_to_consumable_array/* default */.Z)(prev.locations).concat([
                filterName
            ]);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                locations: locations
            });
        });
    };
    var handleSetTagFilter = function(filterName) {
        setFullFilter(function(prev) {
            var tags = prev.tags.includes(filterName) ? prev.tags.filter(function(tag) {
                return tag !== filterName;
            }) : (0,_to_consumable_array/* default */.Z)(prev.tags).concat([
                filterName
            ]);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                tags: tags
            });
        });
    };
    var handleSetDateFilter = function(dateFrom, dateTo) {
        setFullFilter(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                dates: {
                    dateFrom: dateFrom,
                    dateTo: dateTo
                }
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* default */.Z, {
                className: (programme_index_module_default()).filterScroll,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(mainButton/* default */.Z, {
                        className: [
                            (programme_index_module_default()).item,
                            !!fullFilter.dates ? (programme_index_module_default()).selected : null, 
                        ].join(" "),
                        onClick: function() {
                            setOpen(true);
                        },
                        children: [
                            accountTexts.calendar,
                            " ",
                            ((ref = fullFilter.dates) === null || ref === void 0 ? void 0 : ref.dateFrom) && ((ref1 = fullFilter.dates) === null || ref1 === void 0 ? void 0 : ref1.dateTo) && "".concat(formatSimpleDate(fullFilter.dates.dateFrom, language), " → ").concat(formatSimpleDate(fullFilter.dates.dateTo, language))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_fullFilter/* default */.Z, {
                        tags: tags,
                        useCapacityFilter: false,
                        fullFilter: fullFilter,
                        handleResetFilter: handleResetFilter,
                        handleSetLocationFilter: handleSetLocationFilter,
                        handleSetCapacityFilter: function() {},
                        handleSetTagFilter: handleSetTagFilter
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_modal/* default */.Z, {
                open: open,
                onClose: function() {
                    setOpen(false);
                },
                showAnimation: "expand",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (programme_index_module_default()).calendarModalContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(calendar, {
                            handleCloseCalendar: function() {
                                setOpen(false);
                            },
                            handleSetDateFilter: handleSetDateFilter,
                            value: fullFilter.dates
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                            className: (programme_index_module_default()).removeDateFilter,
                            disabled: !fullFilter.dates,
                            onClick: function() {
                                setFullFilter(function(prev) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                        dates: undefined
                                    });
                                });
                                setOpen(false);
                            },
                            children: language === "En" ? "Reset" : "R\xe9initialiser"
                        })
                    ]
                })
            }),
            showHighlights && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (programme_index_module_default()).highlightsContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (programme_index_module_default()).titleContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Highlights"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                children: "".concat(formatNumber(highlightedEvents.length), " ").concat(accountTexts.event).concat(highlightedEvents.length > 1 ? "s" : "")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(highlightsCarousel, {
                        events: highlightedEvents
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (programme_index_module_default()).eventsGrid,
                children: Object.entries(filteredEvents).sort(function(param, param1) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _keyA = _param[0], a = _param[1], _param1 = (0,_sliced_to_array/* default */.Z)(param1, 2), _keyB = _param1[0], b = _param1[1];
                    return a.date < b.date ? -1 : 1;
                }).map(function(param, index) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _key = _param[0], ref = _param[1], header = ref.header, data = ref.data;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(weekScroller, {
                        weekHeader: header,
                        data: data
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var programme = (Programme);

;// CONCATENATED MODULE: ./src/api/users/createSponsorCode.ts



var createSponsorCode = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,axios/* sendRequest */.wG)({
                        method: "post",
                        url: "/user/create-sponsor-code",
                        data: input
                    });
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function createSponsorCode(input) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/api/users/sendSponsorEmail.ts



var sendSponsorEmail = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,axios/* sendRequest */.wG)({
                        method: "post",
                        url: "/user/send-sponsor-code-email",
                        data: input
                    });
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendSponsorEmail(input) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/components/account/sponsoship/index.module.scss
var sponsoship_index_module = __webpack_require__(6132);
var sponsoship_index_module_default = /*#__PURE__*/__webpack_require__.n(sponsoship_index_module);
;// CONCATENATED MODULE: ./src/components/account/sponsoship/index.tsx














var AccountSponsorship = function() {
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, getValues = ref.getValues;
    var ref1 = (0,react.useState)(), sponsorCode = ref1[0], setSponsorCode = ref1[1];
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var intro = language === "En" ? en/* default.accountPage.sponsorship.intro */.Z.accountPage.sponsorship.intro : fr/* default.accountPage.sponsorship.intro */.Z.accountPage.sponsorship.intro;
    var friendInfo = language === "En" ? en/* default.accountPage.sponsorship.friendInfo */.Z.accountPage.sponsorship.friendInfo : fr/* default.accountPage.sponsorship.friendInfo */.Z.accountPage.sponsorship.friendInfo;
    var firstName = language === "En" ? en/* default.accountPage.sponsorship.firstName */.Z.accountPage.sponsorship.firstName : fr/* default.accountPage.sponsorship.firstName */.Z.accountPage.sponsorship.firstName;
    var lastName = language === "En" ? en/* default.accountPage.sponsorship.lastName */.Z.accountPage.sponsorship.lastName : fr/* default.accountPage.sponsorship.lastName */.Z.accountPage.sponsorship.lastName;
    var email = language === "En" ? en/* default.accountPage.sponsorship.email */.Z.accountPage.sponsorship.email : fr/* default.accountPage.sponsorship.email */.Z.accountPage.sponsorship.email;
    var send = language === "En" ? en/* default.accountPage.sponsorship.send */.Z.accountPage.sponsorship.send : fr/* default.accountPage.sponsorship.send */.Z.accountPage.sponsorship.send;
    var sponsorCodeText = language === "En" ? en/* default.accountPage.sponsorship.sponsorCode */.Z.accountPage.sponsorship.sponsorCode : fr/* default.accountPage.sponsorship.sponsorCode */.Z.accountPage.sponsorship.sponsorCode;
    var sponsorCodeRequest = language === "En" ? en/* default.accountPage.sponsorship.sponsorCodeRequest */.Z.accountPage.sponsorship.sponsorCodeRequest : fr/* default.accountPage.sponsorship.sponsorCodeRequest */.Z.accountPage.sponsorship.sponsorCodeRequest;
    var sendByEmail = language === "En" ? en/* default.accountPage.sponsorship.sendByEmail */.Z.accountPage.sponsorship.sendByEmail : fr/* default.accountPage.sponsorship.sendByEmail */.Z.accountPage.sponsorship.sendByEmail;
    var generateCode = language === "En" ? en/* default.accountPage.sponsorship.generateCode */.Z.accountPage.sponsorship.generateCode : fr/* default.accountPage.sponsorship.generateCode */.Z.accountPage.sponsorship.generateCode;
    var sponsorErrorMessage = language === "En" ? en/* default.accountPage.sponsorship.sponsorErrorMessage */.Z.accountPage.sponsorship.sponsorErrorMessage : fr/* default.accountPage.sponsorship.sponsorErrorMessage */.Z.accountPage.sponsorship.sponsorErrorMessage;
    var generateSponsorCodeFirst = language === "En" ? en/* default.accountPage.sponsorship.generateSponsorCodeFirst */.Z.accountPage.sponsorship.generateSponsorCodeFirst : fr/* default.accountPage.sponsorship.generateSponsorCodeFirst */.Z.accountPage.sponsorship.generateSponsorCodeFirst;
    var sponsorCodeSent = language === "En" ? en/* default.accountPage.sponsorship.sponsorCodeSent */.Z.accountPage.sponsorship.sponsorCodeSent : fr/* default.accountPage.sponsorship.sponsorCodeSent */.Z.accountPage.sponsorship.sponsorCodeSent;
    var mutate = (0,es.useMutation)(createSponsorCode, {
        onSuccess: function(res) {
            setSponsorCode(res.code);
        },
        onError: function(error) {
            ;
        }
    }).mutate;
    var ref2 = (0,es.useMutation)(sendSponsorEmail, {
        onSuccess: function() {
            react_toastify_esm/* toast.success */.Am.success(sponsorCodeSent);
        },
        onError: function(error) {
            ;
        }
    }), emailMutate = ref2.mutate;
    var sendEmail = function(data) {
        emailMutate(data);
    };
    var handleSend = function() {
        var ref = getValues(), firstname = ref.firstname, email = ref.email;
        if (sponsorCode && email && firstname) {
            sendEmail({
                code: sponsorCode,
                email: email,
                firstname: firstname
            });
        } else {
            if (!sponsorCode) {
                react_toastify_esm/* toast.error */.Am.error(generateSponsorCodeFirst);
                return;
            } else {
                react_toastify_esm/* toast.error */.Am.error(sponsorErrorMessage);
            }
        }
    };
    var onSubmit = function(data) {
        var firstname = data.firstname, lastname = data.lastname;
        mutate({
            firstname: firstname,
            lastname: lastname
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (sponsoship_index_module_default()).accountSponsorship,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: intro
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                            children: friendInfo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "firstname",
                            children: firstName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("firstname")), {
                            placeholder: "".concat(firstName, "*"),
                            size: 15
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "lastname",
                            children: lastName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("lastname")), {
                            placeholder: "".concat(lastName, "*"),
                            size: 15
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                            className: (sponsoship_index_module_default()).sendButton,
                            type: "submit",
                            children: generateCode
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: sponsorCodeText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (sponsoship_index_module_default()).code,
                        children: [
                            sponsorCode !== null && sponsorCode !== void 0 ? sponsorCode : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (sponsoship_index_module_default())["default"],
                                children: "*** *** ***"
                            }),
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: sponsorCodeRequest
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: sendByEmail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "email",
                className: (sponsoship_index_module_default()).labelClass,
                children: email
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("email")), {
                placeholder: "".concat(email, "*"),
                size: 15,
                className: (sponsoship_index_module_default()).inputClass
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                className: (sponsoship_index_module_default()).sendButton,
                onClick: handleSend,
                children: send
            })
        ]
    });
};
/* harmony default export */ var sponsoship = (AccountSponsorship);

// EXTERNAL MODULE: ./src/components/account/subscriptionSuggestionPopup/index.module.scss
var subscriptionSuggestionPopup_index_module = __webpack_require__(4114);
var subscriptionSuggestionPopup_index_module_default = /*#__PURE__*/__webpack_require__.n(subscriptionSuggestionPopup_index_module);
;// CONCATENATED MODULE: ./src/components/account/subscriptionSuggestionPopup/index.tsx









var SubscriptionSuggestionPopup = function() {
    var user = (0,auth/* useAuth */.aC)().user;
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(true), modalOpen = ref[0], setModalOpen = ref[1];
    // if user is not preselected and doesn't have a subscription and month is not december return null
    if (!(user && user.type === userEnums_types/* UserType.PRE_SELECTED */.FW.PRE_SELECTED && (!user.subscription || user.subscription.subscriptionStatus === subscription_types/* SubscriptionStatus.PENDING */.y.PENDING) && new Date().getMonth() === 11)) return null;
    var handleSetModalClose = function() {
        setModalOpen(false);
    };
    var reduced = user.subscriptionType === "REDUCED_MEMBER";
    var special = user.subscriptionType === "SPECIAL";
    var handleClick = function() {
        router.push("/account?tab=Membership");
    };
    var tab = router.query.tab;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_modal/* default */.Z, {
        open: tab ? false : modalOpen,
        onClose: handleSetModalClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (subscriptionSuggestionPopup_index_module_default()).container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    language === "En" ? "Hello" : "Bonjour",
                    " ",
                    user.firstname,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    language === "En" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (subscriptionSuggestionPopup_index_module_default()).indent,
                        children: [
                            "Our special anniversary offer expires soon. You only have one month left to enjoy our program for free. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "The good news? Until December 31st, you can renew your Silencio subscription at a special rate. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Activate your subscription for",
                            " ",
                            reduced ? 600 : special ? 900 : 1200,
                            "€ / year (or",
                            " ",
                            reduced ? 50 : special ? 75 : 100,
                            "€/month)"
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (subscriptionSuggestionPopup_index_module_default()).indent,
                        children: [
                            "Notre offre sp\xe9ciale anniversaire expire bient\xf4t. Il ne vous reste plus qu’un mois pour profiter de notre programmation gratuitement.",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "La bonne nouvelle ? Jusqu’au 31 d\xe9cembre, vous b\xe9n\xe9ficiez d’un tarif ami pour le renouvellement de votre abonnement Silencio.",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Activez votre abonnement ",
                            reduced ? 600 : special ? 900 : 1200,
                            "€ / an (soit ",
                            reduced ? 50 : special ? 75 : 100,
                            "€/mois)"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (subscriptionSuggestionPopup_index_module_default()).activateButton,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: handleClick,
                            children: language === "En" ? "Subscribe" : "S'abonner"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var subscriptionSuggestionPopup = (/*#__PURE__*/(0,react.memo)(SubscriptionSuggestionPopup));

// EXTERNAL MODULE: ./src/components/account/display/index.module.scss
var display_index_module = __webpack_require__(6302);
var display_index_module_default = /*#__PURE__*/__webpack_require__.n(display_index_module);
;// CONCATENATED MODULE: ./src/components/account/display/index.tsx

















var $7Days = 6048e5; // 7 days in milliseconds = 1000 * 60 * 60 * 24 * 7
var AccountDisplay = function(param) {
    var events = param.events, tags = param.tags;
    var ref;
    var ref1 = (0,react.useState)(AccountSectionEnum.PROGRAMMATION), filter = ref1[0], setFilter = ref1[1];
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var user = (0,auth/* useAuth */.aC)().user;
    var validatedUserWithoutSubscription = (user === null || user === void 0 ? void 0 : user.status) === userEnums_types/* UserStatus.VALIDATED */.J0.VALIDATED && user.subscriptionStatus === userEnums_types/* UserSubscriptionStatus.NONE */.NB.NONE;
    var userWithFailedSubscription = user && user.status === userEnums_types/* UserStatus.VALIDATED */.J0.VALIDATED && ((ref = user.subscription) === null || ref === void 0 ? void 0 : ref.subscriptionStatus) === subscription_types/* SubscriptionStatus.FAILED */.y.FAILED && !!user.subscription.failedDate && new Date().getTime() - new Date(user.subscription.failedDate).getTime() > $7Days;
    var userLimitedAccess = validatedUserWithoutSubscription || userWithFailedSubscription || (user === null || user === void 0 ? void 0 : user.status) !== userEnums_types/* UserStatus.VALIDATED */.J0.VALIDATED;
    var accountSectionPages = {
        Programmation: /*#__PURE__*/ (0,jsx_runtime.jsx)(programme, {
            events: events,
            tags: tags
        }),
        Agenda: /*#__PURE__*/ (0,jsx_runtime.jsx)(agenda, {}),
        Membership: /*#__PURE__*/ (0,jsx_runtime.jsx)(membership, {}),
        Parrainage: /*#__PURE__*/ (0,jsx_runtime.jsx)(sponsoship, {}),
        Anniversaire: /*#__PURE__*/ (0,jsx_runtime.jsx)(birthday, {}),
        Sponsorship: /*#__PURE__*/ (0,jsx_runtime.jsx)(sponsoship, {}),
        Birthday: /*#__PURE__*/ (0,jsx_runtime.jsx)(birthday, {})
    };
    // const accountSectionPagesEn: Record<AccountSectionEnumEn, JSX.Element> = {
    //   Programmation: <Programme events={events} tags={tags} />,
    //   Agenda: <Agenda />,
    //   Membership: <Membership />,
    // };
    var handleSetFilter = function(filterName) {
        setFilter(filterName);
    };
    if (userLimitedAccess) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                accountSectionPages.Membership,
                userWithFailedSubscription && /*#__PURE__*/ (0,jsx_runtime.jsx)(failedSubscriptionPopup, {
                    firstName: user.firstname,
                    lastName: user.lastname
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (display_index_module_default()).accountFilterSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_filter/* default */.Z, {
                    items: getAccountSectionsByLanguage(language),
                    hiddenItems: (user === null || user === void 0 ? void 0 : user.type) === userEnums_types/* UserType.PRE_SELECTED */.FW.PRE_SELECTED ? [
                        AccountSectionEnum.BIRTHDAY
                    ] : undefined,
                    filteredItems: [
                        filter
                    ],
                    handleSetFilter: handleSetFilter,
                    className: (display_index_module_default()).filter,
                    mapToName: function(section) {
                        return section;
                    }
                })
            }),
            accountSectionPages[filter],
            /*#__PURE__*/ (0,jsx_runtime.jsx)(subscriptionSuggestionPopup, {})
        ]
    });
};
/* harmony default export */ var display = (AccountDisplay);

// EXTERNAL MODULE: ./src/components/account/intro/index.module.scss
var intro_index_module = __webpack_require__(8776);
var intro_index_module_default = /*#__PURE__*/__webpack_require__.n(intro_index_module);
;// CONCATENATED MODULE: ./src/components/account/intro/index.tsx










var AccountIntro = function() {
    var user = (0,auth/* useAuth */.aC)().user;
    var myEvents = (0,events/* useEvent */.z)().myEvents;
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var accountTexts = language === "En" ? en/* default.accountPage */.Z.accountPage : fr/* default.accountPage */.Z.accountPage;
    var attending = myEvents.filter(function(param) {
        var booking = param.booking;
        return (booking === null || booking === void 0 ? void 0 : booking.status) === eventEnums_type/* BookingStatus.MAIN */.gn.MAIN;
    }).length;
    var waitlist = myEvents.filter(function(param) {
        var booking = param.booking;
        return (booking === null || booking === void 0 ? void 0 : booking.status) === eventEnums_type/* BookingStatus.WAITING */.gn.WAITING;
    }).length;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "p-1 bbg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (intro_index_module_default())["account-welcome-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: (intro_index_module_default()).accountWelcome,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (intro_index_module_default()).welcome,
                            children: [
                                accountTexts.welcome,
                                ", "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (intro_index_module_default()).welcomeName,
                            children: ((ref = user === null || user === void 0 ? void 0 : user.firstname) !== null && ref !== void 0 ? ref : "") + " " + ((ref1 = user === null || user === void 0 ? void 0 : user.lastname) !== null && ref1 !== void 0 ? ref1 : "")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (intro_index_module_default()).infoContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (intro_index_module_default()).info,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (intro_index_module_default()).topInfo,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (intro_index_module_default()).topButtons,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                                className: (intro_index_module_default()).item,
                                                onClick: function() {},
                                                children: accountTexts.member
                                            }),
                                            "\xa0"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (intro_index_module_default()).bottomInfo,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (intro_index_module_default()).topBottomInfo,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (intro_index_module_default()).bottomInfoNumbers,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (intro_index_module_default()).buttonLabel,
                                                        children: [
                                                            accountTexts.attending,
                                                            "\xa0"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                                        className: (intro_index_module_default()).item,
                                                        onClick: function() {},
                                                        children: formatNumber(attending)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (intro_index_module_default()).bottomInfoNumbers,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (intro_index_module_default()).buttonLabel,
                                                        children: [
                                                            accountTexts.waitingList,
                                                            "\xa0"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                                        className: (intro_index_module_default()).item,
                                                        onClick: function() {},
                                                        children: formatNumber(waitlist)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        (user === null || user === void 0 ? void 0 : user.profilePicturePath) && /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: user.profilePicturePath,
                                className: (intro_index_module_default()).accountImage,
                                alt: "profile"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var intro = (AccountIntro);

// EXTERNAL MODULE: ./src/components/PendingPaymentCard/index.module.scss
var PendingPaymentCard_index_module = __webpack_require__(8899);
var PendingPaymentCard_index_module_default = /*#__PURE__*/__webpack_require__.n(PendingPaymentCard_index_module);
;// CONCATENATED MODULE: ./src/components/PendingPaymentCard/index.tsx




var PendingPaymentCard = function(param) {
    var close = param.close;
    var queryClient = (0,es.useQueryClient)();
    (0,react.useEffect)(function() {
        setTimeout(function() {
            queryClient.invalidateQueries([
                "user"
            ]);
            close();
        }, 3000);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PendingPaymentCard_index_module_default()).modalContainer,
        children: "Traitement en cours… Merci de bien vouloir patienter"
    });
};
/* harmony default export */ var components_PendingPaymentCard = (PendingPaymentCard);

// EXTERNAL MODULE: ./src/utils/pages/index.ts
var pages = __webpack_require__(2305);
// EXTERNAL MODULE: ./src/components/wrappers/PrivatePage/index.module.scss
var PrivatePage_index_module = __webpack_require__(1806);
var PrivatePage_index_module_default = /*#__PURE__*/__webpack_require__.n(PrivatePage_index_module);
;// CONCATENATED MODULE: ./src/components/wrappers/PrivatePage/index.tsx







var PrivatePage = function(param) {
    var children = param.children;
    var user = (0,auth/* useAuth */.aC)().user;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (user && router && !user.id) {
            router.push("".concat(pages/* HOME_PAGE */.s, "?redirectTo=").concat(router.pathname));
        }
    }, [
        router,
        user
    ]);
    return (user === null || user === void 0 ? void 0 : user.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PrivatePage_index_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* Loader */.a, {})
    });
};
/* harmony default export */ var wrappers_PrivatePage = (PrivatePage);

// EXTERNAL MODULE: ./src/components/application/sections/payment/index.tsx
var payment = __webpack_require__(4347);
// EXTERNAL MODULE: ./src/components/application/sections/success/index.tsx
var success = __webpack_require__(1782);
// EXTERNAL MODULE: ./src/components/wrappers/ValidatedPage/index.module.scss
var ValidatedPage_index_module = __webpack_require__(8034);
var ValidatedPage_index_module_default = /*#__PURE__*/__webpack_require__.n(ValidatedPage_index_module);
;// CONCATENATED MODULE: ./src/components/wrappers/ValidatedPage/index.tsx















var ValidatedPage_PrivatePage = function(param) {
    var children = param.children;
    var ref = (0,auth/* useAuth */.aC)(), user = ref.user, setUser = ref.setUser;
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var modalOpen = (user === null || user === void 0 ? void 0 : user.status) && [
        userEnums_types/* UserStatus.CONFIRMED_PAYMENT */.J0.CONFIRMED_PAYMENT,
        userEnums_types/* UserStatus.CONFIRMED_COGNITO */.J0.CONFIRMED_COGNITO
    ].includes(user.status);
    var applyTexts = language === "En" ? en/* default.applyPage */.Z.applyPage : fr/* default.applyPage */.Z.applyPage;
    var handlePaymentSuccess = function() {
        if (user) {
            setUser((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
                status: userEnums_types/* UserStatus.CONFIRMED_PAYMENT */.J0.CONFIRMED_PAYMENT
            }));
        }
    };
    return (user === null || user === void 0 ? void 0 : user.id) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_modal/* default */.Z, {
                open: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ValidatedPage_index_module_default()).modalContainer,
                    children: [
                        user.status === userEnums_types/* UserStatus.CONFIRMED_COGNITO */.J0.CONFIRMED_COGNITO ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: applyTexts.header
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(payment/* default */.Z, {
                                    handleNext: handlePaymentSuccess
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(success/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                            href: "/",
                            style: {
                                textTransform: "none"
                            },
                            children: applyTexts.back
                        })
                    ]
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ValidatedPage_index_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* Loader */.a, {})
    });
};
/* harmony default export */ var ValidatedPage = (ValidatedPage_PrivatePage);

;// CONCATENATED MODULE: ./src/pages/account/index.tsx













var Account = function(param) {
    var tags = param.tags, events = param.events;
    var data = (0,es.useQuery)("events", getAllEvents).data;
    var query = (0,next_router.useRouter)().query;
    var ref = (0,react.useState)(false), modal = ref[0], setModal = ref[1];
    (0,react.useEffect)(function() {
        if (query.return_from_stripe) setModal(true);
    }, [
        query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(wrappers_PrivatePage, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ValidatedPage, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: "Silencio - Account"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {
                        width: "100%",
                        height: "150px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(intro, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {
                        width: "100%",
                        height: "30px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(display, {
                        events: data !== null && data !== void 0 ? data : events,
                        tags: tags
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_modal/* default */.Z, {
                open: modal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PendingPaymentCard, {
                    close: function() {
                        setModal(false);
                    }
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var account = (Account);


/***/ }),

/***/ 2224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pw": function() { return /* binding */ CapacityEnum; },
/* harmony export */   "by": function() { return /* binding */ EventTypeEnum; },
/* harmony export */   "gn": function() { return /* binding */ BookingStatus; }
/* harmony export */ });
var BookingStatus;
(function(BookingStatus) {
    BookingStatus["WAITING"] = "WAITING";
    BookingStatus["MAIN"] = "MAIN";
})(BookingStatus || (BookingStatus = {}));
var CapacityEnum;
(function(CapacityEnum) {
    CapacityEnum["FROM_1_TO_25"] = "FROM_1_TO_25";
    CapacityEnum["FROM_25_TO_120"] = "FROM_25_TO_120";
    CapacityEnum["FROM_120_TO_250"] = "FROM_120_TO_250";
    CapacityEnum["FROM_250_TO_500"] = "FROM_250_TO_500";
})(CapacityEnum || (CapacityEnum = {}));
var EventTypeEnum;
(function(EventTypeEnum) {
    EventTypeEnum["NORMAL"] = "NORMAL";
    EventTypeEnum["FOOD"] = "FOOD";
})(EventTypeEnum || (EventTypeEnum = {}));


/***/ }),

/***/ 1537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ LocationEnum; }
/* harmony export */ });
var LocationEnum;
(function(LocationEnum) {
    LocationEnum["CLUB"] = "CLUB";
    LocationEnum["DES_PRES"] = "DES_PRES";
    LocationEnum["NYC"] = "NYC";
    LocationEnum["IBIZA"] = "IBIZA";
    LocationEnum["HORS_LES_MURS"] = "HORS_LES_MURS";
})(LocationEnum || (LocationEnum = {}));


/***/ }),

/***/ 5380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G$": function() { return /* binding */ compareCapacity; },
/* harmony export */   "LO": function() { return /* binding */ capacities; },
/* harmony export */   "_F": function() { return /* binding */ numberToCapacity; },
/* harmony export */   "aQ": function() { return /* binding */ capacityToNames; }
/* harmony export */ });
/* harmony import */ var _types_event_eventEnums_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2224);

var capacityToNames = {
    FROM_1_TO_25: "1 → 25",
    FROM_25_TO_120: "25 → 120",
    FROM_120_TO_250: "120 → 250",
    FROM_250_TO_500: "250 → 500"
};
var numberToCapacity = function(cap) {
    if (cap <= 25) {
        return _types_event_eventEnums_type__WEBPACK_IMPORTED_MODULE_0__/* .CapacityEnum.FROM_1_TO_25 */ .Pw.FROM_1_TO_25;
    } else if (cap <= 120) {
        return _types_event_eventEnums_type__WEBPACK_IMPORTED_MODULE_0__/* .CapacityEnum.FROM_25_TO_120 */ .Pw.FROM_25_TO_120;
    } else if (cap <= 250) {
        return _types_event_eventEnums_type__WEBPACK_IMPORTED_MODULE_0__/* .CapacityEnum.FROM_120_TO_250 */ .Pw.FROM_120_TO_250;
    } else {
        return _types_event_eventEnums_type__WEBPACK_IMPORTED_MODULE_0__/* .CapacityEnum.FROM_250_TO_500 */ .Pw.FROM_250_TO_500;
    }
};
var compareCapacity = function(a, b) {
    var aCap = parseInt(a.split("_")[1]);
    var bCap = parseInt(b.split("_")[1]);
    return aCap <= bCap;
};
var capacities = [
    _types_event_eventEnums_type__WEBPACK_IMPORTED_MODULE_0__/* .CapacityEnum.FROM_1_TO_25 */ .Pw.FROM_1_TO_25,
    _types_event_eventEnums_type__WEBPACK_IMPORTED_MODULE_0__/* .CapacityEnum.FROM_25_TO_120 */ .Pw.FROM_25_TO_120,
    _types_event_eventEnums_type__WEBPACK_IMPORTED_MODULE_0__/* .CapacityEnum.FROM_120_TO_250 */ .Pw.FROM_120_TO_250,
    _types_event_eventEnums_type__WEBPACK_IMPORTED_MODULE_0__/* .CapacityEnum.FROM_250_TO_500 */ .Pw.FROM_250_TO_500, 
];


/***/ }),

/***/ 8891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kl": function() { return /* binding */ locations; },
/* harmony export */   "yt": function() { return /* binding */ locationToNames; },
/* harmony export */   "zL": function() { return /* binding */ locationToColors; }
/* harmony export */ });
/* harmony import */ var _types_location_locationEnums_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1537);

var locations = [
    _types_location_locationEnums_types__WEBPACK_IMPORTED_MODULE_0__/* .LocationEnum.CLUB */ .e.CLUB,
    _types_location_locationEnums_types__WEBPACK_IMPORTED_MODULE_0__/* .LocationEnum.DES_PRES */ .e.DES_PRES,
    _types_location_locationEnums_types__WEBPACK_IMPORTED_MODULE_0__/* .LocationEnum.NYC */ .e.NYC,
    _types_location_locationEnums_types__WEBPACK_IMPORTED_MODULE_0__/* .LocationEnum.IBIZA */ .e.IBIZA,
    _types_location_locationEnums_types__WEBPACK_IMPORTED_MODULE_0__/* .LocationEnum.HORS_LES_MURS */ .e.HORS_LES_MURS, 
];
var locationToNames = {
    CLUB: "Silencio",
    IBIZA: "El Silencio",
    HORS_LES_MURS: "Silencio Hors Les Murs",
    NYC: "Silencio NYC",
    DES_PRES: "Silencio Des Pr\xe9s"
};
var locationToColors = {
    CLUB: "#AD9462",
    IBIZA: "#D8895D",
    HORS_LES_MURS: "#A2A1A1",
    NYC: "#FF0000",
    DES_PRES: "#4575D3"
};


/***/ }),

/***/ 7379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getLanguage; }
/* harmony export */ });
var getLanguage = function(elt, key, language) {
    return elt["".concat(key).concat(language)];
};


/***/ }),

/***/ 2305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ HOME_PAGE; }
/* harmony export */ });
var HOME_PAGE = "/";


/***/ }),

/***/ 8899:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"PendingPaymentCard_container__l4_8v","modalContainer":"PendingPaymentCard_modalContainer__b0gei"};

/***/ }),

/***/ 8187:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"eventsGrid":"agenda_eventsGrid__VIE3R"};

/***/ }),

/***/ 7869:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"birthday_paragraph__o_t8Y","fromTo":"birthday_fromTo__p8dET","button":"birthday_button__fBbub"};

/***/ }),

/***/ 8911:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"cancelEvent_container__Jh9kR","buttons":"cancelEvent_buttons__RRg2y"};

/***/ }),

/***/ 2033:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"cannotBookPopup_container___pLQ1","text":"cannotBookPopup_text__8kXjO"};

/***/ }),

/***/ 6302:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"venueDisplay":"display_venueDisplay__lydRL","navLine":"display_navLine__jZQJK","item":"display_item___Goyc","selected":"display_selected__O6Q_Q","filter":"display_filter__Zuzuz","accountFilterSection":"display_accountFilterSection__FE3Ay"};

/***/ }),

/***/ 9428:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"guestButton_modalContainer__STy0p"};

/***/ }),

/***/ 2070:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"guestsModal":"guestForm_guestsModal__EODqO","guestsModalHead":"guestForm_guestsModalHead__ZhBmD","guestForm":"guestForm_guestForm__O8TuO","guestLine":"guestForm_guestLine__36WPz","submitButton":"guestForm_submitButton__vAm9O"};

/***/ }),

/***/ 3943:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"highlightedEvent_container__z4HtN","eventInfoContainer":"highlightedEvent_eventInfoContainer__sS1LX","eventTags":"highlightedEvent_eventTags__f6RDs","eventInfo":"highlightedEvent_eventInfo__gn_g1","spacer":"highlightedEvent_spacer__IEEnz","bookGuests":"highlightedEvent_bookGuests__42r2X","guestsButtonContainer":"highlightedEvent_guestsButtonContainer__ArCXm","eventInfoLine":"highlightedEvent_eventInfoLine__mcRIw","reverse":"highlightedEvent_reverse__nrM0n","eventName":"highlightedEvent_eventName__egiin","eventNameMobile":"highlightedEvent_eventNameMobile__nRXdl","eventLocationTags":"highlightedEvent_eventLocationTags__auXvb","dateTime":"highlightedEvent_dateTime__Fj5_4","eventInfoDescription":"highlightedEvent_eventInfoDescription__uUypW","invitedGuestsContainer":"highlightedEvent_invitedGuestsContainer__pvnHe","invitedGuestsLine":"highlightedEvent_invitedGuestsLine__STJlb","guestName":"highlightedEvent_guestName__Jf_P0","date":"highlightedEvent_date__bP3sD","time":"highlightedEvent_time__i46Om","removeGuest":"highlightedEvent_removeGuest__w8CUu","readMore":"highlightedEvent_readMore__rO_ps","buttonsContainer":"highlightedEvent_buttonsContainer__P359q","waitListButton":"highlightedEvent_waitListButton__UNg5m"};

/***/ }),

/***/ 8581:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"highlightsCarousel_carouselContainer__M0yM4"};

/***/ }),

/***/ 8776:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"account-welcome-container":"intro_account-welcome-container__rCmyl","infoContainer":"intro_infoContainer__nuhOP","accountImage":"intro_accountImage__fEe8l","accountWelcome":"intro_accountWelcome__stQ_t","info":"intro_info__ClrLn","buttonLabel":"intro_buttonLabel__ypYpf","topInfo":"intro_topInfo__ATLKw","topBottomInfo":"intro_topBottomInfo__SNpeJ","topButtons":"intro_topButtons__s5Tx7","bottomInfoNumbers":"intro_bottomInfoNumbers__3UaaM","bottomInfo":"intro_bottomInfo__K_C1y","removeOnMobile":"intro_removeOnMobile___YCA3"};

/***/ }),

/***/ 9652:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"memberEvent_container__JeEeg","eventInfo":"memberEvent_eventInfo__qXU5O","eventTags":"memberEvent_eventTags__uHv8e","eventInfoLine":"memberEvent_eventInfoLine__ejE_O","invitedGuestsContainer":"memberEvent_invitedGuestsContainer__GGa9E","invitedGuestsLine":"memberEvent_invitedGuestsLine__6IjZf","guestName":"memberEvent_guestName__WAuI7","date":"memberEvent_date__E_dAd","time":"memberEvent_time__I1I3m","removeGuest":"memberEvent_removeGuest__pr8cG","imageContainer":"memberEvent_imageContainer__Lt_wk","description":"memberEvent_description__7JuWN","eventNameContainer":"memberEvent_eventNameContainer__8_HzM","eventName":"memberEvent_eventName__8sgNU","eventSubtitle":"memberEvent_eventSubtitle__uWz_w","marquee":"memberEvent_marquee__pqgiO","subtitleAnimation":"memberEvent_subtitleAnimation__SMZwP","buttonsContainer":"memberEvent_buttonsContainer__oexr9","guestsButtonContainer":"memberEvent_guestsButtonContainer__TfjG1","waitListButton":"memberEvent_waitListButton__JezG0","bookButton":"memberEvent_bookButton__JxK38"};

/***/ }),

/***/ 4133:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accountMembershipForm":"form_accountMembershipForm__2DkLX","error":"form_error__gdS3D","noBorder":"form_noBorder__hyBZC"};

/***/ }),

/***/ 2023:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modifyOtherInformation":"membership_modifyOtherInformation__H3_ZW","membershipForm":"membership_membershipForm__3sXOa"};

/***/ }),

/***/ 8518:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"updatePasswordContainer":"updatePassword_updatePasswordContainer__3jrkT","error":"updatePassword_error__lmkm2"};

/***/ }),

/***/ 4898:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loginSectionContainer":"loginSection_loginSectionContainer__VSM9o","label":"loginSection_label__6mfKu"};

/***/ }),

/***/ 8076:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"paymentModal_container__dXmsh","formContainer":"paymentModal_formContainer__Iun9F","heading":"paymentModal_heading__WvQ1L","cardInput":"paymentModal_cardInput__shvBk","error":"paymentModal_error__emyRJ"};

/***/ }),

/***/ 2374:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"subscriptionForm_form__uEZpK","inputContainer":"subscriptionForm_inputContainer__rlOmN","input":"subscriptionForm_input__tCfnW","expirationDate":"subscriptionForm_expirationDate__Zm8Wy"};

/***/ }),

/***/ 2861:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"subscriptionRenewal_container__mydUG","modalContainer":"subscriptionRenewal_modalContainer__vcpSy","buttonsContainer":"subscriptionRenewal_buttonsContainer__dm6Bt","error":"subscriptionRenewal_error__megyZ"};

/***/ }),

/***/ 6095:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filterScroll":"programme_filterScroll__AiaHJ","item":"programme_item__RH91O","selected":"programme_selected__RdV4f","titleContainer":"programme_titleContainer__RcM5y","calendarButton":"programme_calendarButton__Vf48g","eventsGrid":"programme_eventsGrid__A8zy0","calendarModalContainer":"programme_calendarModalContainer__qrj3b","removeDateFilter":"programme_removeDateFilter__A_f49"};

/***/ }),

/***/ 6132:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accountSponsorship":"sponsoship_accountSponsorship__w41b5","code":"sponsoship_code__u0Swi","default":"sponsoship_default__yvJp2","labelClass":"sponsoship_labelClass__S8pm6","inputClass":"sponsoship_inputClass__AHLpL"};

/***/ }),

/***/ 4114:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"subscriptionSuggestionPopup_container__va91y","indent":"subscriptionSuggestionPopup_indent__yHJ_p","right":"subscriptionSuggestionPopup_right__49sTG","activateButton":"subscriptionSuggestionPopup_activateButton__V9u9P"};

/***/ }),

/***/ 7076:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"weekScroller_container__QxZi2","weekInfo":"weekScroller_weekInfo__nNKRV","weekPeriod":"weekScroller_weekPeriod__8a42v","weekDays":"weekScroller_weekDays__whzVJ","active":"weekScroller_active__G0d9e","weekEvents":"weekScroller_weekEvents__6KyHk"};

/***/ }),

/***/ 9392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"calendar_container__J4FaE","calendar":"calendar_calendar__bFdGq","day":"calendar_day__0mjbQ"};

/***/ }),

/***/ 9966:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"failedSubscriptionPopup_container__g4xH5"};

/***/ }),

/***/ 5163:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"genericFilter":"filter_genericFilter__JP4qD","item":"filter_item__lC9f4","selected":"filter_selected__JKwVc","relativeFilter":"filter_relativeFilter__3Lx9m"};

/***/ }),

/***/ 5664:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"genericFilter":"fullFilter_genericFilter__q3GmA","item":"fullFilter_item__adV_k","selected":"fullFilter_selected__kKV3j","relativeFilter":"fullFilter_relativeFilter__WYuh2"};

/***/ }),

/***/ 2519:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading":"loader_loading__j20tW","loading06":"loader_loading06__7eG1M"};

/***/ }),

/***/ 9163:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"genericFilter":"tagFilter_genericFilter__z75pb","item":"tagFilter_item__XYuXW","selected":"tagFilter_selected__BxAOe","relativeFilter":"tagFilter_relativeFilter__YWcZt"};

/***/ }),

/***/ 1806:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivatePage_container__uSf_7","loader":"PrivatePage_loader__rUI_W","spin":"PrivatePage_spin__zCls8"};

/***/ }),

/***/ 8034:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ValidatedPage_container__M0MlH","loader":"ValidatedPage_loader__K_x_T","spin":"ValidatedPage_spin__QwRFp","modalContainer":"ValidatedPage_modalContainer__V8EDG"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [885,679,308,599,774,888,179], function() { return __webpack_exec__(7017); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);